import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  Long: { input: any; output: any; }
  Map_String_ObjectScalar: { input: any; output: any; }
  ObjectScalar: { input: any; output: any; }
};

export enum AiValidationStatusSelector {
  PotentialIssues = 'PotentialIssues',
  Verified = 'Verified'
}

export type AttachmentDto = {
  __typename?: 'AttachmentDto';
  attachmentRequest?: Maybe<AttachmentRequestDto>;
  cdnFileName?: Maybe<Scalars['String']['output']>;
  cdnFullPath?: Maybe<Scalars['String']['output']>;
  cdnPath?: Maybe<Scalars['String']['output']>;
  cdnUri?: Maybe<Scalars['String']['output']>;
  driverDocumentValidations?: Maybe<Array<Maybe<DriverDocumentValidationDto>>>;
  encodedFile?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['LocalDateTime']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<AttachmentStatusSelector>;
  tags?: Maybe<Array<Maybe<TagDto>>>;
  temporalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<UserInfoDto>;
  updatedByUser?: Maybe<UserDto>;
};

export type AttachmentDtoInput = {
  encodedFile?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['LocalDateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagDtoInput>>>;
  temporalId?: InputMaybe<Scalars['Int']['input']>;
};

export type AttachmentRequestDto = {
  __typename?: 'AttachmentRequestDto';
  attachment?: Maybe<AttachmentDto>;
  attachmentId?: Maybe<Scalars['Int']['output']>;
  companyRepresentative?: Maybe<UserInfoDto>;
  companyRepresentativeUser?: Maybe<UserDto>;
  driver?: Maybe<DriverDto>;
  driverId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fleet?: Maybe<FleetDto>;
  fleetId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<TagDto>;
  tagCategoryTag?: Maybe<TagCategoryTagDto>;
  tagId?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<UserInfoDto>;
  updatedByUser?: Maybe<UserDto>;
};

export enum AttachmentStatusSelector {
  Expired = 'Expired',
  Missing = 'Missing',
  PendingVerification = 'PendingVerification',
  Rejected = 'Rejected',
  Verified = 'Verified'
}

export type AttachmentVersionedDto = {
  __typename?: 'AttachmentVersionedDto';
  cdnFileName?: Maybe<Scalars['String']['output']>;
  cdnFullPath?: Maybe<Scalars['String']['output']>;
  cdnPath?: Maybe<Scalars['String']['output']>;
  cdnUri?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['LocalDateTime']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<RevisionDto>;
  size?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<AttachmentStatusSelector>;
  tags?: Maybe<Array<Maybe<TagVersionedDto>>>;
};

export type CountryCodeDto = {
  __typename?: 'CountryCodeDto';
  dialCode?: Maybe<Scalars['String']['output']>;
  digits?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isoCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CountryCodeDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DriverCarNumberDto = {
  __typename?: 'DriverCarNumberDto';
  carNumber?: Maybe<Scalars['Int']['output']>;
  driverId?: Maybe<Scalars['Int']['output']>;
};

export type DriverDocumentValidationDto = {
  __typename?: 'DriverDocumentValidationDto';
  aiValidationNote?: Maybe<Scalars['String']['output']>;
  attachment?: Maybe<AttachmentDto>;
  attachmentId?: Maybe<Scalars['Int']['output']>;
  driverProfile?: Maybe<DriverProfileDto>;
  driverProfileId?: Maybe<Scalars['Int']['output']>;
  extractedFields?: Maybe<Scalars['Map_String_ObjectScalar']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  profileFields?: Maybe<Scalars['Map_String_ObjectScalar']['output']>;
  status?: Maybe<AiValidationStatusSelector>;
  validationDate?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type DriverDto = {
  __typename?: 'DriverDto';
  assignedCarNumber?: Maybe<DriverCarNumberDto>;
  attachments?: Maybe<Array<Maybe<AttachmentDto>>>;
  authPhone?: Maybe<PhoneNumberDto>;
  authPhoneId?: Maybe<Scalars['Int']['output']>;
  billingStatus?: Maybe<DriverStatusSelector>;
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fleet?: Maybe<FleetDto>;
  fleetId?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latestVerifications?: Maybe<Array<Maybe<DriverVerificationDto>>>;
  middleName?: Maybe<Scalars['String']['output']>;
  profiles?: Maybe<Array<Maybe<DriverProfileDto>>>;
  revisions?: Maybe<Array<Maybe<DriverVersionedDto>>>;
  signature?: Maybe<Scalars['ObjectScalar']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  verifications?: Maybe<Array<Maybe<DriverVerificationDto>>>;
};

export type DriverDtoInput = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentDtoInput>>>;
  fleet?: InputMaybe<FleetDtoInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  signature?: InputMaybe<Scalars['ObjectScalar']['input']>;
};

export type DriverProfileDto = {
  __typename?: 'DriverProfileDto';
  attachmentStatus?: Maybe<AttachmentStatusSelector>;
  carNumber?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  driver?: Maybe<DriverDto>;
  driverId?: Maybe<Scalars['Int']['output']>;
  entityAttachmentPreviews?: Maybe<Array<Maybe<EntityAttachmentPreviewDto>>>;
  entityAttachmentTotal?: Maybe<EntityAttachmentTotalDto>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstPaceRideDate?: Maybe<Scalars['LocalDateTime']['output']>;
  fleet?: Maybe<FleetDto>;
  fleetId?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  includedInLOP?: Maybe<IncludedInLopStatus>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latestPaceRideDate?: Maybe<Scalars['LocalDateTime']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDateTime']['output']>;
  status?: Maybe<DriverProfileSelector>;
  terminationDate?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type DriverProfileDtoInput = {
  carNumber?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includedInLOP?: InputMaybe<IncludedInLopStatus>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  terminationDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export enum DriverProfileSelector {
  Active = 'Active',
  NoActivity = 'NoActivity',
  Pending = 'Pending',
  Ready = 'Ready',
  Terminated = 'Terminated'
}

export type DriverSettingDto = {
  __typename?: 'DriverSettingDto';
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum DriverStatusSelector {
  Active = 'Active',
  Deactivated = 'Deactivated',
  OnHold = 'OnHold'
}

export type DriverVerificationDto = {
  __typename?: 'DriverVerificationDto';
  additionalData?: Maybe<Scalars['Map_String_ObjectScalar']['output']>;
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  driver?: Maybe<DriverDto>;
  driverId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<VerificationStatusSelector>;
  verificationDate?: Maybe<Scalars['LocalDateTime']['output']>;
  verificationType?: Maybe<VerificationTypeDto>;
  verificationTypeId?: Maybe<Scalars['Int']['output']>;
};

export type DriverVersionedDto = {
  __typename?: 'DriverVersionedDto';
  attachments?: Maybe<Array<Maybe<AttachmentVersionedDto>>>;
  fleet?: Maybe<FleetVersionedDto>;
  id?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<RevisionDto>;
};

export type EntityAttachmentPreviewDto = {
  __typename?: 'EntityAttachmentPreviewDto';
  attachment?: Maybe<AttachmentDto>;
  attachmentExpiredAt?: Maybe<Scalars['LocalDateTime']['output']>;
  attachmentId?: Maybe<Scalars['Int']['output']>;
  attachmentStatus?: Maybe<AttachmentStatusSelector>;
  currentProfile?: Maybe<Scalars['Boolean']['output']>;
  driver?: Maybe<DriverDto>;
  driverId?: Maybe<Scalars['Int']['output']>;
  driverProfile?: Maybe<DriverProfileDto>;
  driverProfileId?: Maybe<Scalars['Int']['output']>;
  expiresSoon?: Maybe<Scalars['Boolean']['output']>;
  fleet?: Maybe<FleetDto>;
  fleetId?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tag?: Maybe<TagDto>;
  tagCategory?: Maybe<TagCategoryDto>;
  tagCategoryId?: Maybe<Scalars['Int']['output']>;
  tagCategoryTag?: Maybe<TagCategoryTagDto>;
  tagCategoryTagId?: Maybe<Scalars['Int']['output']>;
  tagExpirationReminder?: Maybe<Scalars['Int']['output']>;
  tagId?: Maybe<Scalars['Int']['output']>;
};

export type EntityAttachmentTotalDto = {
  __typename?: 'EntityAttachmentTotalDto';
  currentProfile?: Maybe<Scalars['Boolean']['output']>;
  driverId?: Maybe<Scalars['Int']['output']>;
  driverProfileId?: Maybe<Scalars['Int']['output']>;
  expiredAttachments?: Maybe<Scalars['Int']['output']>;
  expiresSoonAttachments?: Maybe<Scalars['Int']['output']>;
  fleetId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  missingAttachments?: Maybe<Scalars['Int']['output']>;
  missingRequiredAttachments?: Maybe<Scalars['Int']['output']>;
  nextExpirationIn?: Maybe<Scalars['Int']['output']>;
  pendingVerificationAttachments?: Maybe<Scalars['Int']['output']>;
  rejectedAttachments?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<AttachmentStatusSelector>;
  totalAttachments?: Maybe<Scalars['Int']['output']>;
  totalTags?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<EntityAttachmentTotalTypeSelector>;
  verifiedAttachments?: Maybe<Scalars['Int']['output']>;
};

export enum EntityAttachmentTotalTypeSelector {
  Driver = 'Driver',
  Fleet = 'Fleet'
}

export type FilterEntryInput = {
  operator?: InputMaybe<FilterOperatorEnum>;
  path?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['ObjectScalar']['input']>;
};

export type FilterExpressionChildInput = {
  entry?: InputMaybe<FilterEntryInput>;
  expr?: InputMaybe<FilterExpressionInput>;
};

export type FilterExpressionInput = {
  children?: InputMaybe<Array<InputMaybe<FilterExpressionChildInput>>>;
  operator?: InputMaybe<FilterExpressionOperatorEnum>;
};

export enum FilterExpressionOperatorEnum {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR'
}

export enum FilterOperatorEnum {
  Contains = 'CONTAINS',
  Empty = 'EMPTY',
  EndsWith = 'ENDS_WITH',
  Equal = 'EQUAL',
  GreaterEqual = 'GREATER_EQUAL',
  GreaterThan = 'GREATER_THAN',
  In = 'IN',
  Like = 'LIKE',
  LowerEqual = 'LOWER_EQUAL',
  LowerThan = 'LOWER_THAN',
  NotEmpty = 'NOT_EMPTY',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN',
  NotNull = 'NOT_NULL',
  Null = 'NULL',
  StartsWith = 'STARTS_WITH'
}

export type FleetDto = {
  __typename?: 'FleetDto';
  affiliate?: Maybe<Scalars['Boolean']['output']>;
  attachments?: Maybe<Array<Maybe<AttachmentDto>>>;
  boroughs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  companyId?: Maybe<Scalars['Int']['output']>;
  companyOwnerEmail?: Maybe<Scalars['String']['output']>;
  companyOwnerFullname?: Maybe<Scalars['String']['output']>;
  companyOwnerPhoneNumber?: Maybe<PhoneNumberDto>;
  companyRepresentativeUser?: Maybe<UserDto>;
  entityAttachmentPreviews?: Maybe<Array<Maybe<EntityAttachmentPreviewDto>>>;
  entityAttachmentTotal?: Maybe<EntityAttachmentTotalDto>;
  fleetTagCategories?: Maybe<Array<Maybe<FleetTagCategoryDto>>>;
  id?: Maybe<Scalars['Int']['output']>;
  latestVerifications?: Maybe<Array<Maybe<FleetVerificationDto>>>;
  legacyCompanyId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revisions?: Maybe<Array<Maybe<FleetVersionedDto>>>;
  shortName?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<UserDto>>>;
  verifications?: Maybe<Array<Maybe<FleetVerificationDto>>>;
  workingHours?: Maybe<Scalars['String']['output']>;
};

export type FleetDtoInput = {
  attachments?: InputMaybe<Array<InputMaybe<AttachmentDtoInput>>>;
  boroughs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyOwnerEmail?: InputMaybe<Scalars['String']['input']>;
  companyOwnerFullname?: InputMaybe<Scalars['String']['input']>;
  companyOwnerPhoneNumber?: InputMaybe<PhoneNumberDtoInput>;
  fleetTagCategories?: InputMaybe<Array<InputMaybe<FleetTagCategoryDtoInput>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  workingHours?: InputMaybe<Scalars['String']['input']>;
};

export type FleetTagCategoryDto = {
  __typename?: 'FleetTagCategoryDto';
  appliedTo?: Maybe<TagCategoryAppliedToSelector>;
  fleet?: Maybe<FleetDto>;
  fleetId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sequenceOrder?: Maybe<Scalars['Int']['output']>;
  tagCategory?: Maybe<TagCategoryDto>;
  tagCategoryId?: Maybe<Scalars['Int']['output']>;
  temporalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<UserInfoDto>;
  updatedByUser?: Maybe<UserDto>;
};

export type FleetTagCategoryDtoInput = {
  appliedTo?: InputMaybe<TagCategoryAppliedToSelector>;
  id?: InputMaybe<Scalars['Int']['input']>;
  sequenceOrder?: InputMaybe<Scalars['Int']['input']>;
  tagCategory?: InputMaybe<TagCategoryDtoInput>;
  temporalId?: InputMaybe<Scalars['Int']['input']>;
};

export type FleetTagCategoryVersionedDto = {
  __typename?: 'FleetTagCategoryVersionedDto';
  appliedTo?: Maybe<TagCategoryAppliedToSelector>;
  fleetId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<RevisionDto>;
  sequenceOrder?: Maybe<Scalars['Int']['output']>;
  tagCategory?: Maybe<TagCategoryVersionedDto>;
  tagCategoryId?: Maybe<Scalars['Int']['output']>;
};

export type FleetVerificationDto = {
  __typename?: 'FleetVerificationDto';
  additionalData?: Maybe<Scalars['Map_String_ObjectScalar']['output']>;
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  fleet?: Maybe<FleetDto>;
  fleetId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<VerificationStatusSelector>;
  verificationDate?: Maybe<Scalars['LocalDateTime']['output']>;
  verificationType?: Maybe<VerificationTypeDto>;
  verificationTypeId?: Maybe<Scalars['Int']['output']>;
};

export type FleetVersionedDto = {
  __typename?: 'FleetVersionedDto';
  attachments?: Maybe<Array<Maybe<AttachmentVersionedDto>>>;
  fleetTagCategories?: Maybe<Array<Maybe<FleetTagCategoryVersionedDto>>>;
  id?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<RevisionDto>;
};

export enum IncludedInLopStatus {
  Ignored = 'Ignored',
  Included = 'Included',
  NewToLop = 'NewToLOP'
}

export type InviteUserDtoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fleet?: InputMaybe<FleetDtoInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  validationStrategy?: InputMaybe<ValidationStrategyEnum>;
};

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  appendAttachmentToDriverProfile?: Maybe<MutationResult_AttachmentDto>;
  appendAttachmentToFleet?: Maybe<MutationResult_AttachmentDto>;
  appendAttachmentsToDriverProfile?: Maybe<MutationResult_List_AttachmentDto>;
  appendAttachmentsToFleet?: Maybe<MutationResult_List_AttachmentDto>;
  createTag?: Maybe<MutationResult_TagDto>;
  createTagCategory?: Maybe<MutationResult_TagCategoryDto>;
  createVerificationType?: Maybe<MutationResult_VerificationTypeDto>;
  deactivateProfile?: Maybe<MutationResult_DriverProfileDto>;
  deleteAttachment: Scalars['Boolean']['output'];
  deleteTag: Scalars['Boolean']['output'];
  deleteTagCategory: Scalars['Boolean']['output'];
  deleteVerificationType: Scalars['Boolean']['output'];
  importDispatchDriverProfileDocumentsFromSource: Scalars['Boolean']['output'];
  inviteManager?: Maybe<MutationResult_UserDto>;
  me?: Maybe<MutationResult_UserDto>;
  reactivateProfile?: Maybe<MutationResult_DriverProfileDto>;
  registerDriverProfileAttachmentRequest?: Maybe<Scalars['String']['output']>;
  registerFleetAttachmentRequest?: Maybe<Scalars['String']['output']>;
  rejectAttachment: Scalars['Boolean']['output'];
  setDriverProfileIncludedToLOPStatus: Scalars['Long']['output'];
  setDriverSignature?: Maybe<DriverSettingDto>;
  setSetting?: Maybe<UserSettingDto>;
  updateDocumentStatus?: Maybe<MutationResult_DriverProfileDto>;
  updateDriver?: Maybe<MutationResult_DriverDto>;
  updateDriverProfile?: Maybe<MutationResult_DriverProfileDto>;
  updateFleet?: Maybe<MutationResult_FleetDto>;
  updateTag?: Maybe<MutationResult_TagDto>;
  updateTagCategory?: Maybe<MutationResult_TagCategoryDto>;
  updateVerificationType?: Maybe<MutationResult_VerificationTypeDto>;
  verifyAttachment: Scalars['Boolean']['output'];
};


/** Mutation root */
export type MutationAppendAttachmentToDriverProfileArgs = {
  driverProfileId: Scalars['Int']['input'];
  input: MutationInput_AttachmentDtoInput;
};


/** Mutation root */
export type MutationAppendAttachmentToFleetArgs = {
  fleetId: Scalars['Int']['input'];
  input: MutationInput_AttachmentDtoInput;
};


/** Mutation root */
export type MutationAppendAttachmentsToDriverProfileArgs = {
  driverProfileId: Scalars['Int']['input'];
  input: MutationInput_List_AttachmentDtoInput;
};


/** Mutation root */
export type MutationAppendAttachmentsToFleetArgs = {
  fleetId: Scalars['Int']['input'];
  input: MutationInput_List_AttachmentDtoInput;
};


/** Mutation root */
export type MutationCreateTagArgs = {
  input: MutationInput_TagDtoInput;
};


/** Mutation root */
export type MutationCreateTagCategoryArgs = {
  input: MutationInput_TagCategoryDtoInput;
};


/** Mutation root */
export type MutationCreateVerificationTypeArgs = {
  input: MutationInput_VerificationTypeDtoInput;
};


/** Mutation root */
export type MutationDeactivateProfileArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationDeleteAttachmentArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteTagArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteTagCategoryArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteVerificationTypeArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationImportDispatchDriverProfileDocumentsFromSourceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationInviteManagerArgs = {
  input: MutationInput_InviteUserDtoInput;
};


/** Mutation root */
export type MutationMeArgs = {
  input: MutationInput_UserDtoInput;
};


/** Mutation root */
export type MutationReactivateProfileArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationRegisterDriverProfileAttachmentRequestArgs = {
  driverProfileId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  tagId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRegisterFleetAttachmentRequestArgs = {
  email: Scalars['String']['input'];
  fleetId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRejectAttachmentArgs = {
  id: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationSetDriverProfileIncludedToLopStatusArgs = {
  includedInLOP?: InputMaybe<IncludedInLopStatus>;
  update?: InputMaybe<UpdateMetaDataInput>;
};


/** Mutation root */
export type MutationSetDriverSignatureArgs = {
  driverId?: InputMaybe<Scalars['Int']['input']>;
  signature?: InputMaybe<Scalars['ObjectScalar']['input']>;
};


/** Mutation root */
export type MutationSetSettingArgs = {
  setting?: InputMaybe<UserSettingDtoInput>;
};


/** Mutation root */
export type MutationUpdateDocumentStatusArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUpdateDriverArgs = {
  input: MutationInput_DriverDtoInput;
};


/** Mutation root */
export type MutationUpdateDriverProfileArgs = {
  input: MutationInput_DriverProfileDtoInput;
};


/** Mutation root */
export type MutationUpdateFleetArgs = {
  input: MutationInput_FleetDtoInput;
};


/** Mutation root */
export type MutationUpdateTagArgs = {
  input: MutationInput_TagDtoInput;
};


/** Mutation root */
export type MutationUpdateTagCategoryArgs = {
  input: MutationInput_TagCategoryDtoInput;
};


/** Mutation root */
export type MutationUpdateVerificationTypeArgs = {
  input: MutationInput_VerificationTypeDtoInput;
};


/** Mutation root */
export type MutationVerifyAttachmentArgs = {
  id: Scalars['Int']['input'];
};

export type MutationInput_AttachmentDtoInput = {
  data: AttachmentDtoInput;
};

export type MutationInput_DriverDtoInput = {
  data: DriverDtoInput;
};

export type MutationInput_DriverProfileDtoInput = {
  data: DriverProfileDtoInput;
};

export type MutationInput_FleetDtoInput = {
  data: FleetDtoInput;
};

export type MutationInput_InviteUserDtoInput = {
  data: InviteUserDtoInput;
};

export type MutationInput_List_AttachmentDtoInput = {
  data: Array<InputMaybe<AttachmentDtoInput>>;
};

export type MutationInput_TagCategoryDtoInput = {
  data: TagCategoryDtoInput;
};

export type MutationInput_TagDtoInput = {
  data: TagDtoInput;
};

export type MutationInput_UserDtoInput = {
  data: UserDtoInput;
};

export type MutationInput_VerificationTypeDtoInput = {
  data: VerificationTypeDtoInput;
};

export type MutationResult_AttachmentDto = {
  __typename?: 'MutationResult_AttachmentDto';
  data?: Maybe<AttachmentDto>;
  success: Scalars['Boolean']['output'];
};

export type MutationResult_DriverDto = {
  __typename?: 'MutationResult_DriverDto';
  data?: Maybe<DriverDto>;
  success: Scalars['Boolean']['output'];
};

export type MutationResult_DriverProfileDto = {
  __typename?: 'MutationResult_DriverProfileDto';
  data?: Maybe<DriverProfileDto>;
  success: Scalars['Boolean']['output'];
};

export type MutationResult_FleetDto = {
  __typename?: 'MutationResult_FleetDto';
  data?: Maybe<FleetDto>;
  success: Scalars['Boolean']['output'];
};

export type MutationResult_List_AttachmentDto = {
  __typename?: 'MutationResult_List_AttachmentDto';
  data?: Maybe<Array<Maybe<AttachmentDto>>>;
  success: Scalars['Boolean']['output'];
};

export type MutationResult_TagCategoryDto = {
  __typename?: 'MutationResult_TagCategoryDto';
  data?: Maybe<TagCategoryDto>;
  success: Scalars['Boolean']['output'];
};

export type MutationResult_TagDto = {
  __typename?: 'MutationResult_TagDto';
  data?: Maybe<TagDto>;
  success: Scalars['Boolean']['output'];
};

export type MutationResult_UserDto = {
  __typename?: 'MutationResult_UserDto';
  data?: Maybe<UserDto>;
  success: Scalars['Boolean']['output'];
};

export type MutationResult_VerificationTypeDto = {
  __typename?: 'MutationResult_VerificationTypeDto';
  data?: Maybe<VerificationTypeDto>;
  success: Scalars['Boolean']['output'];
};

export enum OrderDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderEntryInput = {
  direction?: InputMaybe<OrderDirectionEnum>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type PageMetaDataInput = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type Page_AttachmentDto = {
  __typename?: 'Page_AttachmentDto';
  items?: Maybe<Array<Maybe<AttachmentDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_DriverDocumentValidationDto = {
  __typename?: 'Page_DriverDocumentValidationDto';
  items?: Maybe<Array<Maybe<DriverDocumentValidationDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_DriverDto = {
  __typename?: 'Page_DriverDto';
  items?: Maybe<Array<Maybe<DriverDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_DriverProfileDto = {
  __typename?: 'Page_DriverProfileDto';
  items?: Maybe<Array<Maybe<DriverProfileDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_DriverVerificationDto = {
  __typename?: 'Page_DriverVerificationDto';
  items?: Maybe<Array<Maybe<DriverVerificationDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_EntityAttachmentPreviewDto = {
  __typename?: 'Page_EntityAttachmentPreviewDto';
  items?: Maybe<Array<Maybe<EntityAttachmentPreviewDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_EntityAttachmentTotalDto = {
  __typename?: 'Page_EntityAttachmentTotalDto';
  items?: Maybe<Array<Maybe<EntityAttachmentTotalDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_FleetDto = {
  __typename?: 'Page_FleetDto';
  items?: Maybe<Array<Maybe<FleetDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_FleetVerificationDto = {
  __typename?: 'Page_FleetVerificationDto';
  items?: Maybe<Array<Maybe<FleetVerificationDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_TagCategoryDto = {
  __typename?: 'Page_TagCategoryDto';
  items?: Maybe<Array<Maybe<TagCategoryDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_TagDto = {
  __typename?: 'Page_TagDto';
  items?: Maybe<Array<Maybe<TagDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Page_VerificationTypeDto = {
  __typename?: 'Page_VerificationTypeDto';
  items?: Maybe<Array<Maybe<VerificationTypeDto>>>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PhoneNumberDto = {
  __typename?: 'PhoneNumberDto';
  countryCode?: Maybe<CountryCodeDto>;
  countryCodeId?: Maybe<Scalars['Int']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  fullPhone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberDtoInput = {
  countryCode?: InputMaybe<CountryCodeDtoInput>;
  extension?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Query root */
export type Query = {
  __typename?: 'Query';
  attachment?: Maybe<AttachmentDto>;
  attachments?: Maybe<Page_AttachmentDto>;
  driver?: Maybe<DriverDto>;
  driverDocumentValidation?: Maybe<DriverDocumentValidationDto>;
  driverDocumentValidations?: Maybe<Page_DriverDocumentValidationDto>;
  driverProfile?: Maybe<DriverProfileDto>;
  driverProfiles?: Maybe<Page_DriverProfileDto>;
  driverVerification?: Maybe<DriverVerificationDto>;
  driverVerifications?: Maybe<Page_DriverVerificationDto>;
  drivers?: Maybe<Page_DriverDto>;
  entityAttachmentPreviews?: Maybe<Page_EntityAttachmentPreviewDto>;
  entityAttachmentTotals?: Maybe<Page_EntityAttachmentTotalDto>;
  fleet?: Maybe<FleetDto>;
  fleetVerification?: Maybe<FleetVerificationDto>;
  fleetVerifications?: Maybe<Page_FleetVerificationDto>;
  fleets?: Maybe<Page_FleetDto>;
  me?: Maybe<UserDto>;
  setting?: Maybe<UserSettingDto>;
  settings?: Maybe<Array<Maybe<UserSettingDto>>>;
  tag?: Maybe<TagDto>;
  tagCategories?: Maybe<Page_TagCategoryDto>;
  tagCategory?: Maybe<TagCategoryDto>;
  tags?: Maybe<Page_TagDto>;
  verificationType?: Maybe<VerificationTypeDto>;
  verificationTypes?: Maybe<Page_VerificationTypeDto>;
};


/** Query root */
export type QueryAttachmentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryAttachmentsArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryDriverArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryDriverDocumentValidationArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


/** Query root */
export type QueryDriverDocumentValidationsArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryDriverProfileArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryDriverProfilesArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryDriverVerificationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryDriverVerificationsArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryDriversArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryEntityAttachmentPreviewsArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryEntityAttachmentTotalsArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryFleetArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryFleetVerificationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryFleetVerificationsArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryFleetsArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QuerySettingArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryTagArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryTagCategoriesArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryTagCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryTagsArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};


/** Query root */
export type QueryVerificationTypeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryVerificationTypesArgs = {
  query?: InputMaybe<QueryMetaDataInput>;
};

export type QueryMetaDataInput = {
  filter?: InputMaybe<FilterExpressionChildInput>;
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>>>;
  page?: InputMaybe<PageMetaDataInput>;
};

export type RevisionDto = {
  __typename?: 'RevisionDto';
  id?: Maybe<Scalars['Int']['output']>;
  iss?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserDto>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum TagCategoryAppliedToSelector {
  Affiliate = 'Affiliate',
  Driver = 'Driver'
}

export type TagCategoryDto = {
  __typename?: 'TagCategoryDto';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tagCategoryTags?: Maybe<Array<Maybe<TagCategoryTagDto>>>;
  temporalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<UserInfoDto>;
  updatedByUser?: Maybe<UserDto>;
};

export type TagCategoryDtoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagCategoryTags?: InputMaybe<Array<InputMaybe<TagCategoryTagDtoInput>>>;
  temporalId?: InputMaybe<Scalars['Int']['input']>;
};

export type TagCategoryTagDto = {
  __typename?: 'TagCategoryTagDto';
  displayName?: Maybe<Scalars['String']['output']>;
  expirationReminder?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sequenceOrder?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<TagDto>;
  tagCategory?: Maybe<TagCategoryDto>;
  tagCategoryId?: Maybe<Scalars['Int']['output']>;
  tagId?: Maybe<Scalars['Int']['output']>;
  temporalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<UserInfoDto>;
  updatedByUser?: Maybe<UserDto>;
};

export type TagCategoryTagDtoInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  expirationReminder?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sequenceOrder?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<TagDtoInput>;
  temporalId?: InputMaybe<Scalars['Int']['input']>;
};

export type TagCategoryTagVersionedDto = {
  __typename?: 'TagCategoryTagVersionedDto';
  displayName?: Maybe<Scalars['String']['output']>;
  expirationReminder?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  revision?: Maybe<RevisionDto>;
  sequenceOrder?: Maybe<Scalars['Int']['output']>;
  tag?: Maybe<TagVersionedDto>;
  tagCategory?: Maybe<TagCategoryVersionedDto>;
  tagCategoryId?: Maybe<Scalars['Int']['output']>;
  tagId?: Maybe<Scalars['Int']['output']>;
};

export type TagCategoryVersionedDto = {
  __typename?: 'TagCategoryVersionedDto';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<RevisionDto>;
  tagCategoryTags?: Maybe<Array<Maybe<TagCategoryTagVersionedDto>>>;
};

export type TagDto = {
  __typename?: 'TagDto';
  attachmentRequestAllowed?: Maybe<Scalars['Boolean']['output']>;
  defaultExpiredIn?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDateRequired?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isGeneral?: Maybe<Scalars['Boolean']['output']>;
  manualUploadAllowed?: Maybe<Scalars['Boolean']['output']>;
  multipleAttachmentAllowed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  systemId?: Maybe<Scalars['String']['output']>;
  temporalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<UserInfoDto>;
  updatedByUser?: Maybe<UserDto>;
  validationStrategy?: Maybe<ValidationStrategyEnum>;
};

export type TagDtoInput = {
  attachmentRequestAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  defaultExpiredIn?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expirationDateRequired?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isGeneral?: InputMaybe<Scalars['Boolean']['input']>;
  manualUploadAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  multipleAttachmentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  systemId?: InputMaybe<Scalars['String']['input']>;
  temporalId?: InputMaybe<Scalars['Int']['input']>;
  validationStrategy?: InputMaybe<ValidationStrategyEnum>;
};

export type TagVersionedDto = {
  __typename?: 'TagVersionedDto';
  defaultExpiredIn?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDateRequired?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<RevisionDto>;
  systemId?: Maybe<Scalars['String']['output']>;
};

export type UpdateMetaDataInput = {
  filter?: InputMaybe<FilterExpressionChildInput>;
};

export type UserDto = {
  __typename?: 'UserDto';
  email?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  iss?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['ObjectScalar']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserDtoInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['ObjectScalar']['input']>;
};

export type UserInfoDto = {
  __typename?: 'UserInfoDto';
  iss?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserSettingDto = {
  __typename?: 'UserSettingDto';
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type UserSettingDtoInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ValidationStrategyEnum {
  Create = 'CREATE',
  Update = 'UPDATE'
}

export enum VerificationStatusSelector {
  Pending = 'Pending',
  Rejected = 'Rejected',
  Verified = 'Verified'
}

export enum VerificationTypeApplyToSelector {
  Affiliate = 'Affiliate',
  Both = 'Both',
  Driver = 'Driver'
}

export type VerificationTypeDto = {
  __typename?: 'VerificationTypeDto';
  applyTo?: Maybe<VerificationTypeApplyToSelector>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  systemId?: Maybe<Scalars['String']['output']>;
  temporalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<UserInfoDto>;
  updatedByUser?: Maybe<UserDto>;
};

export type VerificationTypeDtoInput = {
  applyTo?: InputMaybe<VerificationTypeApplyToSelector>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  systemId?: InputMaybe<Scalars['String']['input']>;
  temporalId?: InputMaybe<Scalars['Int']['input']>;
};

export type VerifyAttachmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type VerifyAttachmentMutation = { __typename?: 'Mutation', verifyAttachment: boolean };

export type RejectAttachmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
}>;


export type RejectAttachmentMutation = { __typename?: 'Mutation', rejectAttachment: boolean };

export type GetAttachmentPreviewsQueryVariables = Exact<{
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetAttachmentPreviewsQuery = { __typename?: 'Query', entityAttachmentPreviews?: { __typename?: 'Page_EntityAttachmentPreviewDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'EntityAttachmentPreviewDto', tagCategoryTag?: { __typename?: 'TagCategoryTagDto', id?: number | null, displayName?: string | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null } | null } | null, driver?: { __typename?: 'DriverDto', id?: number | null, assignedCarNumber?: { __typename?: 'DriverCarNumberDto', carNumber?: number | null } | null } | null, driverProfile?: { __typename?: 'DriverProfileDto', id?: number | null, firstName?: string | null, lastName?: string | null, carNumber?: number | null, status?: DriverProfileSelector | null } | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, users?: Array<{ __typename?: 'UserDto', id?: string | null, email?: string | null } | null> | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, rejectionReason?: string | null, attachmentRequest?: { __typename?: 'AttachmentRequestDto', id?: number | null, email?: string | null } | null } | null } | null> | null } | null };

export type UpdateMySignatureMutationVariables = Exact<{
  values: UserDtoInput;
}>;


export type UpdateMySignatureMutation = { __typename?: 'Mutation', me?: { __typename?: 'MutationResult_UserDto', success: boolean, data?: { __typename?: 'UserDto', id?: string | null, signature?: any | null } | null } | null };

export type DeleteAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['Int']['input'];
}>;


export type DeleteAttachmentMutation = { __typename?: 'Mutation', deleteAttachment: boolean };

export type GetAttachmentInfoQueryVariables = Exact<{
  fileId: Scalars['Int']['input'];
}>;


export type GetAttachmentInfoQuery = { __typename?: 'Query', attachment?: { __typename?: 'AttachmentDto', id?: number | null, name?: string | null, extension?: string | null, cdnUri?: string | null, size?: number | null } | null };

export type GetAttachmentsInfoQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetAttachmentsInfoQuery = { __typename?: 'Query', attachments?: { __typename?: 'Page_AttachmentDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'AttachmentDto', id?: number | null, name?: string | null, extension?: string | null, cdnUri?: string | null, size?: number | null } | null> | null } | null };

export type UpdateMeMutationVariables = Exact<{
  values: UserDtoInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', me?: { __typename?: 'MutationResult_UserDto', success: boolean, data?: { __typename?: 'UserDto', id?: string | null, lastName?: string | null, firstName?: string | null, signature?: any | null } | null } | null };

export type GetUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingsQuery = { __typename?: 'Query', settings?: Array<{ __typename?: 'UserSettingDto', id?: number | null, key?: string | null, value?: string | null } | null> | null };

export type SetSettingMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type SetSettingMutation = { __typename?: 'Mutation', setSetting?: { __typename?: 'UserSettingDto', id?: number | null } | null };

export type DriverVerificationInfoFragment = { __typename?: 'DriverVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, systemId?: string | null } | null };

export type FleetVerificationInfoFragment = { __typename?: 'FleetVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, systemId?: string | null } | null };

export type GetDriverSelectQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetDriverSelectQuery = { __typename?: 'Query', drivers?: { __typename?: 'Page_DriverDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'DriverDto', id?: number | null, ssn?: string | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null } | null, assignedCarNumber?: { __typename?: 'DriverCarNumberDto', driverId?: number | null, carNumber?: number | null } | null } | null> | null } | null };

export type GetFleetsSelectQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetFleetsSelectQuery = { __typename?: 'Query', fleets?: { __typename?: 'Page_FleetDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'FleetDto', id?: number | null, shortName?: string | null, name?: string | null, legacyCompanyId?: number | null } | null> | null } | null };

export type TagCategorySelectFieldsFragment = { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null };

export type GetTagCategoriesSelectQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetTagCategoriesSelectQuery = { __typename?: 'Query', tagCategories?: { __typename?: 'Page_TagCategoryDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'TagCategoryDto', id?: number | null, name?: string | null } | null> | null } | null };

export type TagSelectFieldsFragment = { __typename?: 'TagDto', id?: number | null, name?: string | null, expirationDateRequired?: boolean | null };

export type GetTagsSelectQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetTagsSelectQuery = { __typename?: 'Query', tags?: { __typename?: 'Page_TagDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'TagDto', id?: number | null, name?: string | null, expirationDateRequired?: boolean | null } | null> | null } | null };

export type GetDriverExpirationInfoQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDriverExpirationInfoQuery = { __typename?: 'Query', driverProfile?: { __typename?: 'DriverProfileDto', id?: number | null, entityAttachmentPreviews?: Array<{ __typename?: 'EntityAttachmentPreviewDto', attachmentId?: number | null, attachmentStatus?: AttachmentStatusSelector | null, attachmentExpiredAt?: any | null, expiresSoon?: boolean | null, required?: boolean | null, tagCategoryTag?: { __typename?: 'TagCategoryTagDto', id?: number | null, displayName?: string | null, sequenceOrder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null } | null } | null } | null> | null } | null };

export type GetDriverTypeVerificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDriverTypeVerificationsQuery = { __typename?: 'Query', verificationTypes?: { __typename?: 'Page_VerificationTypeDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null } | null> | null } | null };

export type GetDriverProfilesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetDriverProfilesQuery = { __typename?: 'Query', driverProfiles?: { __typename?: 'Page_DriverProfileDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'DriverProfileDto', id?: number | null, firstName?: string | null, lastName?: string | null, carNumber?: number | null, status?: DriverProfileSelector | null, attachmentStatus?: AttachmentStatusSelector | null, startDate?: any | null, terminationDate?: any | null, includedInLOP?: IncludedInLopStatus | null, firstPaceRideDate?: any | null, latestPaceRideDate?: any | null, driver?: { __typename?: 'DriverDto', id?: number | null, email?: string | null, authPhone?: { __typename?: 'PhoneNumberDto', fullPhone?: string | null } | null, latestVerifications?: Array<{ __typename?: 'DriverVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, systemId?: string | null } | null } | null> | null } | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null } | null, entityAttachmentTotal?: { __typename?: 'EntityAttachmentTotalDto', id?: string | null, nextExpirationIn?: number | null } | null } | null> | null } | null };

export type GetEntityAttachmentsPreviewDownloadQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetEntityAttachmentsPreviewDownloadQuery = { __typename?: 'Query', entityAttachmentPreviews?: { __typename?: 'Page_EntityAttachmentPreviewDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'EntityAttachmentPreviewDto', attachmentStatus?: AttachmentStatusSelector | null, driver?: { __typename?: 'DriverDto', id?: number | null } | null, driverProfile?: { __typename?: 'DriverProfileDto', id?: number | null, includedInLOP?: IncludedInLopStatus | null, startDate?: any | null, fullName?: string | null } | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null } | null, tagCategory?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null } | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, name?: string | null, updatedAt?: any | null } | null } | null> | null } | null };

export type GetEntityAttachmentsPreviewDownloadLinksQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetEntityAttachmentsPreviewDownloadLinksQuery = { __typename?: 'Query', entityAttachmentPreviews?: { __typename?: 'Page_EntityAttachmentPreviewDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'EntityAttachmentPreviewDto', driver?: { __typename?: 'DriverDto', id?: number | null } | null, driverProfile?: { __typename?: 'DriverProfileDto', id?: number | null, lastName?: string | null, firstName?: string | null } | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, name?: string | null, cdnUri?: string | null, size?: number | null, updatedAt?: any | null } | null } | null> | null } | null };

export type GetEntityAttachmentsPreviewQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetEntityAttachmentsPreviewQuery = { __typename?: 'Query', entityAttachmentPreviews?: { __typename?: 'Page_EntityAttachmentPreviewDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'EntityAttachmentPreviewDto', driverProfileId?: number | null, attachmentStatus?: AttachmentStatusSelector | null, expiresSoon?: boolean | null, driver?: { __typename?: 'DriverDto', id?: number | null, email?: string | null } | null, driverProfile?: { __typename?: 'DriverProfileDto', id?: number | null, fullName?: string | null } | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null, companyRepresentativeUser?: { __typename?: 'UserDto', id?: string | null, email?: string | null } | null } | null, tagCategory?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null } | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, updatedAt?: any | null } | null } | null> | null } | null };

export type SetDriverProfileIncludedToLopStatusMutationVariables = Exact<{
  filter?: InputMaybe<FilterExpressionChildInput>;
  status: IncludedInLopStatus;
}>;


export type SetDriverProfileIncludedToLopStatusMutation = { __typename?: 'Mutation', setDriverProfileIncludedToLOPStatus: any };

export type GetDriverProfilesForLopQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetDriverProfilesForLopQuery = { __typename?: 'Query', driverProfiles?: { __typename?: 'Page_DriverProfileDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'DriverProfileDto', id?: number | null, firstName?: string | null, lastName?: string | null, startDate?: any | null, terminationDate?: any | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null } | null, driver?: { __typename?: 'DriverDto', id?: number | null } | null } | null> | null } | null };

export type GetDriverProfilesCountQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetDriverProfilesCountQuery = { __typename?: 'Query', driverProfiles?: { __typename?: 'Page_DriverProfileDto', totalElements: any } | null };

export type TerminateProfileMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TerminateProfileMutation = { __typename?: 'Mutation', deactivateProfile?: { __typename?: 'MutationResult_DriverProfileDto', success: boolean } | null };

export type ReevaluateDocumentStatusMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReevaluateDocumentStatusMutation = { __typename?: 'Mutation', updateDocumentStatus?: { __typename?: 'MutationResult_DriverProfileDto', success: boolean } | null };

export type ReactivateProfileMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReactivateProfileMutation = { __typename?: 'Mutation', reactivateProfile?: { __typename?: 'MutationResult_DriverProfileDto', success: boolean, data?: { __typename?: 'DriverProfileDto', id?: number | null } | null } | null };

export type AppendAttachmentToDriverProfileMutationVariables = Exact<{
  driverProfileId: Scalars['Int']['input'];
  values: AttachmentDtoInput;
}>;


export type AppendAttachmentToDriverProfileMutation = { __typename?: 'Mutation', appendAttachmentToDriverProfile?: { __typename?: 'MutationResult_AttachmentDto', success: boolean } | null };

export type RegisterDriverProfileAttachmentRequestMutationVariables = Exact<{
  driverProfileId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
}>;


export type RegisterDriverProfileAttachmentRequestMutation = { __typename?: 'Mutation', registerDriverProfileAttachmentRequest?: string | null };

export type SaveDriverSignatureMutationVariables = Exact<{
  driverId: Scalars['Int']['input'];
  signature: Scalars['ObjectScalar']['input'];
}>;


export type SaveDriverSignatureMutation = { __typename?: 'Mutation', setDriverSignature?: { __typename?: 'DriverSettingDto', id?: number | null } | null };

export type DriverProfileFormTagInfoFragment = { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null };

export type DriverProfileFormTagCategoryTagInfoFragment = { __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null };

export type DriverProfileFormFragment = { __typename?: 'DriverProfileDto', id?: number | null, carNumber?: number | null, status?: DriverProfileSelector | null, attachmentStatus?: AttachmentStatusSelector | null, firstPaceRideDate?: any | null, latestPaceRideDate?: any | null, createdAt?: any | null, startDate?: any | null, terminationDate?: any | null, includedInLOP?: IncludedInLopStatus | null, firstName?: string | null, lastName?: string | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null, fleetTagCategories?: Array<{ __typename?: 'FleetTagCategoryDto', id?: number | null, sequenceOrder?: number | null, appliedTo?: TagCategoryAppliedToSelector | null, tagCategory?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null } | null> | null } | null } | null> | null, companyRepresentativeUser?: { __typename?: 'UserDto', id?: string | null, firstName?: string | null, lastName?: string | null, signature?: any | null, email?: string | null } | null } | null, entityAttachmentPreviews?: Array<{ __typename?: 'EntityAttachmentPreviewDto', tagCategoryId?: number | null, expiresSoon?: boolean | null, tagCategoryTag?: { __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, name?: string | null, size?: number | null, updatedAt?: any | null, rejectionReason?: string | null, status?: AttachmentStatusSelector | null, expiredAt?: any | null, updatedByUser?: { __typename?: 'UserDto', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null> | null, attachmentRequest?: { __typename?: 'AttachmentRequestDto', id?: number | null, email?: string | null } | null, driverDocumentValidations?: Array<{ __typename?: 'DriverDocumentValidationDto', id?: any | null, driverProfileId?: number | null, status?: AiValidationStatusSelector | null, extractedFields?: any | null, profileFields?: any | null, aiValidationNote?: string | null } | null> | null } | null } | null> | null, driver?: { __typename?: 'DriverDto', id?: number | null, email?: string | null, ssn?: string | null, signature?: any | null, authPhone?: { __typename?: 'PhoneNumberDto', fullPhone?: string | null } | null, profiles?: Array<{ __typename?: 'DriverProfileDto', id?: number | null, carNumber?: number | null, status?: DriverProfileSelector | null, attachmentStatus?: AttachmentStatusSelector | null, startDate?: any | null, terminationDate?: any | null, createdAt?: any | null, firstPaceRideDate?: any | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null } | null } | null> | null, verifications?: Array<{ __typename?: 'DriverVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', description?: string | null, id?: number | null, name?: string | null, systemId?: string | null } | null } | null> | null } | null };

export type GetDriverProfileQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDriverProfileQuery = { __typename?: 'Query', driverProfile?: { __typename?: 'DriverProfileDto', id?: number | null, carNumber?: number | null, status?: DriverProfileSelector | null, attachmentStatus?: AttachmentStatusSelector | null, firstPaceRideDate?: any | null, latestPaceRideDate?: any | null, createdAt?: any | null, startDate?: any | null, terminationDate?: any | null, includedInLOP?: IncludedInLopStatus | null, firstName?: string | null, lastName?: string | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null, fleetTagCategories?: Array<{ __typename?: 'FleetTagCategoryDto', id?: number | null, sequenceOrder?: number | null, appliedTo?: TagCategoryAppliedToSelector | null, tagCategory?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null } | null> | null } | null } | null> | null, companyRepresentativeUser?: { __typename?: 'UserDto', id?: string | null, firstName?: string | null, lastName?: string | null, signature?: any | null, email?: string | null } | null } | null, entityAttachmentPreviews?: Array<{ __typename?: 'EntityAttachmentPreviewDto', tagCategoryId?: number | null, expiresSoon?: boolean | null, tagCategoryTag?: { __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, name?: string | null, size?: number | null, updatedAt?: any | null, rejectionReason?: string | null, status?: AttachmentStatusSelector | null, expiredAt?: any | null, updatedByUser?: { __typename?: 'UserDto', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null> | null, attachmentRequest?: { __typename?: 'AttachmentRequestDto', id?: number | null, email?: string | null } | null, driverDocumentValidations?: Array<{ __typename?: 'DriverDocumentValidationDto', id?: any | null, driverProfileId?: number | null, status?: AiValidationStatusSelector | null, extractedFields?: any | null, profileFields?: any | null, aiValidationNote?: string | null } | null> | null } | null } | null> | null, driver?: { __typename?: 'DriverDto', id?: number | null, email?: string | null, ssn?: string | null, signature?: any | null, authPhone?: { __typename?: 'PhoneNumberDto', fullPhone?: string | null } | null, profiles?: Array<{ __typename?: 'DriverProfileDto', id?: number | null, carNumber?: number | null, status?: DriverProfileSelector | null, attachmentStatus?: AttachmentStatusSelector | null, startDate?: any | null, terminationDate?: any | null, createdAt?: any | null, firstPaceRideDate?: any | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null } | null } | null> | null, verifications?: Array<{ __typename?: 'DriverVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', description?: string | null, id?: number | null, name?: string | null, systemId?: string | null } | null } | null> | null } | null } | null };

export type UpdateDriverProfileMutationVariables = Exact<{
  values: DriverProfileDtoInput;
}>;


export type UpdateDriverProfileMutation = { __typename?: 'Mutation', updateDriverProfile?: { __typename?: 'MutationResult_DriverProfileDto', success: boolean, data?: { __typename?: 'DriverProfileDto', id?: number | null, carNumber?: number | null, status?: DriverProfileSelector | null, attachmentStatus?: AttachmentStatusSelector | null, firstPaceRideDate?: any | null, latestPaceRideDate?: any | null, createdAt?: any | null, startDate?: any | null, terminationDate?: any | null, includedInLOP?: IncludedInLopStatus | null, firstName?: string | null, lastName?: string | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null, fleetTagCategories?: Array<{ __typename?: 'FleetTagCategoryDto', id?: number | null, sequenceOrder?: number | null, appliedTo?: TagCategoryAppliedToSelector | null, tagCategory?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null } | null> | null } | null } | null> | null, companyRepresentativeUser?: { __typename?: 'UserDto', id?: string | null, firstName?: string | null, lastName?: string | null, signature?: any | null, email?: string | null } | null } | null, entityAttachmentPreviews?: Array<{ __typename?: 'EntityAttachmentPreviewDto', tagCategoryId?: number | null, expiresSoon?: boolean | null, tagCategoryTag?: { __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, name?: string | null, size?: number | null, updatedAt?: any | null, rejectionReason?: string | null, status?: AttachmentStatusSelector | null, expiredAt?: any | null, updatedByUser?: { __typename?: 'UserDto', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null> | null, attachmentRequest?: { __typename?: 'AttachmentRequestDto', id?: number | null, email?: string | null } | null, driverDocumentValidations?: Array<{ __typename?: 'DriverDocumentValidationDto', id?: any | null, driverProfileId?: number | null, status?: AiValidationStatusSelector | null, extractedFields?: any | null, profileFields?: any | null, aiValidationNote?: string | null } | null> | null } | null } | null> | null, driver?: { __typename?: 'DriverDto', id?: number | null, email?: string | null, ssn?: string | null, signature?: any | null, authPhone?: { __typename?: 'PhoneNumberDto', fullPhone?: string | null } | null, profiles?: Array<{ __typename?: 'DriverProfileDto', id?: number | null, carNumber?: number | null, status?: DriverProfileSelector | null, attachmentStatus?: AttachmentStatusSelector | null, startDate?: any | null, terminationDate?: any | null, createdAt?: any | null, firstPaceRideDate?: any | null, fleet?: { __typename?: 'FleetDto', id?: number | null, name?: string | null, shortName?: string | null, legacyCompanyId?: number | null } | null } | null> | null, verifications?: Array<{ __typename?: 'DriverVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', description?: string | null, id?: number | null, name?: string | null, systemId?: string | null } | null } | null> | null } | null } | null } | null };

export type GetFleetsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetFleetsQuery = { __typename?: 'Query', fleets?: { __typename?: 'Page_FleetDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'FleetDto', id?: number | null, legacyCompanyId?: number | null, name?: string | null, shortName?: string | null, latestVerifications?: Array<{ __typename?: 'FleetVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', description?: string | null, id?: number | null, name?: string | null, systemId?: string | null } | null } | null> | null } | null> | null } | null };

export type GetAffiliateTypeVerificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAffiliateTypeVerificationsQuery = { __typename?: 'Query', verificationTypes?: { __typename?: 'Page_VerificationTypeDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null } | null> | null } | null };

export type GetFleetsCountQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetFleetsCountQuery = { __typename?: 'Query', fleets?: { __typename?: 'Page_FleetDto', totalElements: any } | null };

export type AppendAttachmentToFleetMutationVariables = Exact<{
  fleetId: Scalars['Int']['input'];
  values: AttachmentDtoInput;
}>;


export type AppendAttachmentToFleetMutation = { __typename?: 'Mutation', appendAttachmentToFleet?: { __typename?: 'MutationResult_AttachmentDto', success: boolean } | null };

export type RegisterFleetAttachmentRequestMutationVariables = Exact<{
  fleetId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
}>;


export type RegisterFleetAttachmentRequestMutation = { __typename?: 'Mutation', registerFleetAttachmentRequest?: string | null };

export type InviteUserMutationVariables = Exact<{
  values: InviteUserDtoInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteManager?: { __typename?: 'MutationResult_UserDto', success: boolean, data?: { __typename?: 'UserDto', id?: string | null, lastName?: string | null, firstName?: string | null, email?: string | null } | null } | null };

export type FleetFormFragment = { __typename?: 'FleetDto', id?: number | null, legacyCompanyId?: number | null, name?: string | null, shortName?: string | null, workingHours?: string | null, boroughs?: Array<string | null> | null, companyOwnerFullname?: string | null, companyOwnerEmail?: string | null, entityAttachmentPreviews?: Array<{ __typename?: 'EntityAttachmentPreviewDto', tagCategoryId?: number | null, tagCategoryTag?: { __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, name?: string | null, size?: number | null, updatedAt?: any | null, rejectionReason?: string | null, status?: AttachmentStatusSelector | null, expiredAt?: any | null, updatedByUser?: { __typename?: 'UserDto', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'TagDto', id?: number | null } | null> | null, attachmentRequest?: { __typename?: 'AttachmentRequestDto', id?: number | null, email?: string | null } | null } | null } | null> | null, fleetTagCategories?: Array<{ __typename?: 'FleetTagCategoryDto', id?: number | null, sequenceOrder?: number | null, appliedTo?: TagCategoryAppliedToSelector | null, tagCategory?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', tag?: { __typename?: 'TagDto', id?: number | null, attachmentRequestAllowed?: boolean | null } | null } | null> | null } | null } | null> | null, users?: Array<{ __typename?: 'UserDto', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, enabled: boolean, signature?: any | null } | null> | null, companyRepresentativeUser?: { __typename?: 'UserDto', id?: string | null, firstName?: string | null, lastName?: string | null, signature?: any | null, email?: string | null } | null, companyOwnerPhoneNumber?: { __typename?: 'PhoneNumberDto', phone?: string | null, countryCode?: { __typename?: 'CountryCodeDto', id?: number | null, isoCode?: string | null, dialCode?: string | null } | null } | null, verifications?: Array<{ __typename?: 'FleetVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, systemId?: string | null } | null } | null> | null };

export type GetFleetQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFleetQuery = { __typename?: 'Query', fleet?: { __typename?: 'FleetDto', id?: number | null, legacyCompanyId?: number | null, name?: string | null, shortName?: string | null, workingHours?: string | null, boroughs?: Array<string | null> | null, companyOwnerFullname?: string | null, companyOwnerEmail?: string | null, entityAttachmentPreviews?: Array<{ __typename?: 'EntityAttachmentPreviewDto', tagCategoryId?: number | null, tagCategoryTag?: { __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, name?: string | null, size?: number | null, updatedAt?: any | null, rejectionReason?: string | null, status?: AttachmentStatusSelector | null, expiredAt?: any | null, updatedByUser?: { __typename?: 'UserDto', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'TagDto', id?: number | null } | null> | null, attachmentRequest?: { __typename?: 'AttachmentRequestDto', id?: number | null, email?: string | null } | null } | null } | null> | null, fleetTagCategories?: Array<{ __typename?: 'FleetTagCategoryDto', id?: number | null, sequenceOrder?: number | null, appliedTo?: TagCategoryAppliedToSelector | null, tagCategory?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', tag?: { __typename?: 'TagDto', id?: number | null, attachmentRequestAllowed?: boolean | null } | null } | null> | null } | null } | null> | null, users?: Array<{ __typename?: 'UserDto', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, enabled: boolean, signature?: any | null } | null> | null, companyRepresentativeUser?: { __typename?: 'UserDto', id?: string | null, firstName?: string | null, lastName?: string | null, signature?: any | null, email?: string | null } | null, companyOwnerPhoneNumber?: { __typename?: 'PhoneNumberDto', phone?: string | null, countryCode?: { __typename?: 'CountryCodeDto', id?: number | null, isoCode?: string | null, dialCode?: string | null } | null } | null, verifications?: Array<{ __typename?: 'FleetVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, systemId?: string | null } | null } | null> | null } | null };

export type UpdateFleetMutationVariables = Exact<{
  values: FleetDtoInput;
}>;


export type UpdateFleetMutation = { __typename?: 'Mutation', updateFleet?: { __typename?: 'MutationResult_FleetDto', success: boolean, data?: { __typename?: 'FleetDto', id?: number | null, legacyCompanyId?: number | null, name?: string | null, shortName?: string | null, workingHours?: string | null, boroughs?: Array<string | null> | null, companyOwnerFullname?: string | null, companyOwnerEmail?: string | null, entityAttachmentPreviews?: Array<{ __typename?: 'EntityAttachmentPreviewDto', tagCategoryId?: number | null, tagCategoryTag?: { __typename?: 'TagCategoryTagDto', id?: number | null, sequenceOrder?: number | null, displayName?: string | null, required?: boolean | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null } | null } | null, attachment?: { __typename?: 'AttachmentDto', id?: number | null, name?: string | null, size?: number | null, updatedAt?: any | null, rejectionReason?: string | null, status?: AttachmentStatusSelector | null, expiredAt?: any | null, updatedByUser?: { __typename?: 'UserDto', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, tags?: Array<{ __typename?: 'TagDto', id?: number | null } | null> | null, attachmentRequest?: { __typename?: 'AttachmentRequestDto', id?: number | null, email?: string | null } | null } | null } | null> | null, fleetTagCategories?: Array<{ __typename?: 'FleetTagCategoryDto', id?: number | null, sequenceOrder?: number | null, appliedTo?: TagCategoryAppliedToSelector | null, tagCategory?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', tag?: { __typename?: 'TagDto', id?: number | null, attachmentRequestAllowed?: boolean | null } | null } | null> | null } | null } | null> | null, users?: Array<{ __typename?: 'UserDto', id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, enabled: boolean, signature?: any | null } | null> | null, companyRepresentativeUser?: { __typename?: 'UserDto', id?: string | null, firstName?: string | null, lastName?: string | null, signature?: any | null, email?: string | null } | null, companyOwnerPhoneNumber?: { __typename?: 'PhoneNumberDto', phone?: string | null, countryCode?: { __typename?: 'CountryCodeDto', id?: number | null, isoCode?: string | null, dialCode?: string | null } | null } | null, verifications?: Array<{ __typename?: 'FleetVerificationDto', id?: number | null, status?: VerificationStatusSelector | null, verificationDate?: any | null, createdAt?: any | null, additionalData?: any | null, verificationType?: { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, systemId?: string | null } | null } | null> | null } | null } | null };

export type GetTagCategoriesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetTagCategoriesQuery = { __typename?: 'Query', tagCategories?: { __typename?: 'Page_TagCategoryDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, description?: string | null, updatedAt?: any | null, updatedByUser?: { __typename?: 'UserDto', id?: string | null, username?: string | null, email?: string | null } | null } | null> | null } | null };

export type TagCategoryFormFragment = { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, description?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', id?: number | null, displayName?: string | null, required?: boolean | null, sequenceOrder?: number | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, expirationDateRequired?: boolean | null } | null } | null> | null };

export type GetTagCategoryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTagCategoryQuery = { __typename?: 'Query', tagCategory?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, description?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', id?: number | null, displayName?: string | null, required?: boolean | null, sequenceOrder?: number | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, expirationDateRequired?: boolean | null } | null } | null> | null } | null };

export type CreateTagCategoryMutationVariables = Exact<{
  values: TagCategoryDtoInput;
}>;


export type CreateTagCategoryMutation = { __typename?: 'Mutation', createTagCategory?: { __typename?: 'MutationResult_TagCategoryDto', success: boolean, data?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, description?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', id?: number | null, displayName?: string | null, required?: boolean | null, sequenceOrder?: number | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, expirationDateRequired?: boolean | null } | null } | null> | null } | null } | null };

export type UpdateTagCategoryMutationVariables = Exact<{
  values: TagCategoryDtoInput;
}>;


export type UpdateTagCategoryMutation = { __typename?: 'Mutation', updateTagCategory?: { __typename?: 'MutationResult_TagCategoryDto', success: boolean, data?: { __typename?: 'TagCategoryDto', id?: number | null, name?: string | null, description?: string | null, tagCategoryTags?: Array<{ __typename?: 'TagCategoryTagDto', id?: number | null, displayName?: string | null, required?: boolean | null, sequenceOrder?: number | null, expirationReminder?: number | null, tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, expirationDateRequired?: boolean | null } | null } | null> | null } | null } | null };

export type DeleteTagCategoryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTagCategoryMutation = { __typename?: 'Mutation', deleteTagCategory: boolean };

export type GetTagsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetTagsQuery = { __typename?: 'Query', tags?: { __typename?: 'Page_TagDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'TagDto', id?: number | null, name?: string | null, systemId?: string | null, description?: string | null, updatedAt?: any | null, updatedByUser?: { __typename?: 'UserDto', id?: string | null, username?: string | null, email?: string | null } | null } | null> | null } | null };

export type TagFormFragment = { __typename?: 'TagDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null, isGeneral?: boolean | null };

export type GetTagQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTagQuery = { __typename?: 'Query', tag?: { __typename?: 'TagDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null, isGeneral?: boolean | null } | null };

export type CreateTagMutationVariables = Exact<{
  values: TagDtoInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag?: { __typename?: 'MutationResult_TagDto', success: boolean, data?: { __typename?: 'TagDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null, isGeneral?: boolean | null } | null } | null };

export type UpdateTagMutationVariables = Exact<{
  values: TagDtoInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag?: { __typename?: 'MutationResult_TagDto', success: boolean, data?: { __typename?: 'TagDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null, expirationDateRequired?: boolean | null, defaultExpiredIn?: number | null, multipleAttachmentAllowed?: boolean | null, attachmentRequestAllowed?: boolean | null, manualUploadAllowed?: boolean | null, isGeneral?: boolean | null } | null } | null };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: boolean };

export type GetVerificationTypesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  orders?: InputMaybe<Array<InputMaybe<OrderEntryInput>> | InputMaybe<OrderEntryInput>>;
  filter?: InputMaybe<FilterExpressionChildInput>;
}>;


export type GetVerificationTypesQuery = { __typename?: 'Query', verificationTypes?: { __typename?: 'Page_VerificationTypeDto', totalPages: number, totalElements: any, items?: Array<{ __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, systemId?: string | null, description?: string | null, applyTo?: VerificationTypeApplyToSelector | null, updatedAt?: any | null, updatedByUser?: { __typename?: 'UserDto', id?: string | null, username?: string | null, email?: string | null } | null } | null> | null } | null };

export type VerificationTypeFormFragment = { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null, applyTo?: VerificationTypeApplyToSelector | null };

export type GetVerificationTypeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVerificationTypeQuery = { __typename?: 'Query', verificationType?: { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null, applyTo?: VerificationTypeApplyToSelector | null } | null };

export type CreateVerificationTypeMutationVariables = Exact<{
  values: VerificationTypeDtoInput;
}>;


export type CreateVerificationTypeMutation = { __typename?: 'Mutation', createVerificationType?: { __typename?: 'MutationResult_VerificationTypeDto', success: boolean, data?: { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null, applyTo?: VerificationTypeApplyToSelector | null } | null } | null };

export type UpdateVerificationTypeMutationVariables = Exact<{
  values: VerificationTypeDtoInput;
}>;


export type UpdateVerificationTypeMutation = { __typename?: 'Mutation', updateVerificationType?: { __typename?: 'MutationResult_VerificationTypeDto', success: boolean, data?: { __typename?: 'VerificationTypeDto', id?: number | null, name?: string | null, description?: string | null, systemId?: string | null, applyTo?: VerificationTypeApplyToSelector | null } | null } | null };

export type DeleteVerificationTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteVerificationTypeMutation = { __typename?: 'Mutation', deleteVerificationType: boolean };

export const TagCategorySelectFieldsFragmentDoc = gql`
    fragment tagCategorySelectFields on TagCategoryDto {
  id
  name
}
    `;
export const TagSelectFieldsFragmentDoc = gql`
    fragment tagSelectFields on TagDto {
  id
  name
  expirationDateRequired
}
    `;
export const DriverProfileFormTagInfoFragmentDoc = gql`
    fragment driverProfileFormTagInfo on TagDto {
  id
  name
  systemId
  expirationDateRequired
  defaultExpiredIn
  multipleAttachmentAllowed
  attachmentRequestAllowed
  manualUploadAllowed
}
    `;
export const DriverProfileFormTagCategoryTagInfoFragmentDoc = gql`
    fragment driverProfileFormTagCategoryTagInfo on TagCategoryTagDto {
  id
  sequenceOrder
  tag {
    ...driverProfileFormTagInfo
  }
  displayName
  required
  expirationReminder
}
    ${DriverProfileFormTagInfoFragmentDoc}`;
export const DriverVerificationInfoFragmentDoc = gql`
    fragment driverVerificationInfo on DriverVerificationDto {
  id
  status
  verificationDate
  createdAt
  additionalData
  verificationType {
    id
    name
    systemId
  }
}
    `;
export const DriverProfileFormFragmentDoc = gql`
    fragment driverProfileForm on DriverProfileDto {
  id
  carNumber
  status
  attachmentStatus
  firstPaceRideDate
  latestPaceRideDate
  createdAt
  startDate
  terminationDate
  includedInLOP
  firstName
  lastName
  fleet {
    id
    name
    shortName
    legacyCompanyId
    fleetTagCategories {
      id
      sequenceOrder
      appliedTo
      tagCategory {
        id
        name
        tagCategoryTags {
          ...driverProfileFormTagCategoryTagInfo
        }
      }
    }
    companyRepresentativeUser {
      id
      firstName
      lastName
      signature
      email
    }
  }
  entityAttachmentPreviews {
    tagCategoryId
    tagCategoryTag {
      ...driverProfileFormTagCategoryTagInfo
    }
    attachment {
      id
      name
      size
      updatedAt
      updatedByUser {
        id
        email
        firstName
        lastName
      }
      tags {
        ...driverProfileFormTagInfo
      }
      attachmentRequest {
        id
        email
      }
      rejectionReason
      status
      expiredAt
      driverDocumentValidations {
        id
        driverProfileId
        status
        extractedFields
        profileFields
        aiValidationNote
      }
    }
    expiresSoon
  }
  driver {
    id
    email
    ssn
    authPhone {
      fullPhone
    }
    profiles {
      id
      fleet {
        id
        name
        shortName
        legacyCompanyId
      }
      carNumber
      status
      attachmentStatus
      startDate
      terminationDate
      createdAt
      firstPaceRideDate
    }
    signature
    verifications {
      ...driverVerificationInfo
      verificationType {
        description
      }
    }
  }
}
    ${DriverProfileFormTagCategoryTagInfoFragmentDoc}
${DriverProfileFormTagInfoFragmentDoc}
${DriverVerificationInfoFragmentDoc}`;
export const FleetVerificationInfoFragmentDoc = gql`
    fragment fleetVerificationInfo on FleetVerificationDto {
  id
  status
  verificationDate
  createdAt
  additionalData
  verificationType {
    id
    name
    systemId
  }
}
    `;
export const FleetFormFragmentDoc = gql`
    fragment fleetForm on FleetDto {
  id
  legacyCompanyId
  name
  shortName
  entityAttachmentPreviews {
    tagCategoryId
    tagCategoryTag {
      id
      sequenceOrder
      tag {
        id
        name
        systemId
        expirationDateRequired
        defaultExpiredIn
        multipleAttachmentAllowed
        attachmentRequestAllowed
        manualUploadAllowed
      }
      displayName
      required
      expirationReminder
    }
    attachment {
      id
      name
      size
      updatedAt
      updatedByUser {
        id
        email
        firstName
        lastName
      }
      tags {
        id
      }
      attachmentRequest {
        id
        email
      }
      rejectionReason
      status
      expiredAt
    }
  }
  fleetTagCategories {
    id
    sequenceOrder
    appliedTo
    tagCategory {
      id
      name
      tagCategoryTags {
        tag {
          id
          attachmentRequestAllowed
        }
      }
    }
  }
  users {
    id
    email
    firstName
    lastName
    enabled
    signature
  }
  companyRepresentativeUser {
    id
    firstName
    lastName
    signature
    email
  }
  workingHours
  boroughs
  companyOwnerFullname
  companyOwnerEmail
  companyOwnerPhoneNumber {
    countryCode {
      id
      isoCode
      dialCode
    }
    phone
  }
  verifications {
    ...fleetVerificationInfo
  }
}
    ${FleetVerificationInfoFragmentDoc}`;
export const TagCategoryFormFragmentDoc = gql`
    fragment tagCategoryForm on TagCategoryDto {
  id
  name
  description
  tagCategoryTags {
    id
    displayName
    required
    sequenceOrder
    expirationReminder
    tag {
      id
      name
      expirationDateRequired
    }
  }
}
    `;
export const TagFormFragmentDoc = gql`
    fragment tagForm on TagDto {
  id
  name
  description
  systemId
  expirationDateRequired
  defaultExpiredIn
  multipleAttachmentAllowed
  attachmentRequestAllowed
  manualUploadAllowed
  isGeneral
}
    `;
export const VerificationTypeFormFragmentDoc = gql`
    fragment verificationTypeForm on VerificationTypeDto {
  id
  name
  description
  systemId
  applyTo
}
    `;
export const VerifyAttachmentDocument = gql`
    mutation verifyAttachment($id: Int!) {
  verifyAttachment(id: $id)
}
    `;
export type VerifyAttachmentMutationFn = Apollo.MutationFunction<VerifyAttachmentMutation, VerifyAttachmentMutationVariables>;

/**
 * __useVerifyAttachmentMutation__
 *
 * To run a mutation, you first call `useVerifyAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAttachmentMutation, { data, loading, error }] = useVerifyAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifyAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAttachmentMutation, VerifyAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAttachmentMutation, VerifyAttachmentMutationVariables>(VerifyAttachmentDocument, options);
      }
export type VerifyAttachmentMutationHookResult = ReturnType<typeof useVerifyAttachmentMutation>;
export type VerifyAttachmentMutationResult = Apollo.MutationResult<VerifyAttachmentMutation>;
export type VerifyAttachmentMutationOptions = Apollo.BaseMutationOptions<VerifyAttachmentMutation, VerifyAttachmentMutationVariables>;
export const RejectAttachmentDocument = gql`
    mutation rejectAttachment($id: Int!, $reason: String!) {
  rejectAttachment(id: $id, reason: $reason)
}
    `;
export type RejectAttachmentMutationFn = Apollo.MutationFunction<RejectAttachmentMutation, RejectAttachmentMutationVariables>;

/**
 * __useRejectAttachmentMutation__
 *
 * To run a mutation, you first call `useRejectAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectAttachmentMutation, { data, loading, error }] = useRejectAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RejectAttachmentMutation, RejectAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectAttachmentMutation, RejectAttachmentMutationVariables>(RejectAttachmentDocument, options);
      }
export type RejectAttachmentMutationHookResult = ReturnType<typeof useRejectAttachmentMutation>;
export type RejectAttachmentMutationResult = Apollo.MutationResult<RejectAttachmentMutation>;
export type RejectAttachmentMutationOptions = Apollo.BaseMutationOptions<RejectAttachmentMutation, RejectAttachmentMutationVariables>;
export const GetAttachmentPreviewsDocument = gql`
    query getAttachmentPreviews($filter: FilterExpressionChildInput) {
  entityAttachmentPreviews(query: {page: {page: 0, size: 10}, filter: $filter}) {
    totalPages
    totalElements
    items {
      tagCategoryTag {
        id
        displayName
        tag {
          id
          name
        }
      }
      driver {
        id
        assignedCarNumber {
          carNumber
        }
      }
      driverProfile {
        id
        firstName
        lastName
        carNumber
        status
      }
      fleet {
        id
        name
        users {
          id
          email
        }
      }
      attachment {
        id
        rejectionReason
        attachmentRequest {
          id
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetAttachmentPreviewsQuery__
 *
 * To run a query within a React component, call `useGetAttachmentPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentPreviewsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAttachmentPreviewsQuery(baseOptions?: Apollo.QueryHookOptions<GetAttachmentPreviewsQuery, GetAttachmentPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentPreviewsQuery, GetAttachmentPreviewsQueryVariables>(GetAttachmentPreviewsDocument, options);
      }
export function useGetAttachmentPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentPreviewsQuery, GetAttachmentPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentPreviewsQuery, GetAttachmentPreviewsQueryVariables>(GetAttachmentPreviewsDocument, options);
        }
export function useGetAttachmentPreviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAttachmentPreviewsQuery, GetAttachmentPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAttachmentPreviewsQuery, GetAttachmentPreviewsQueryVariables>(GetAttachmentPreviewsDocument, options);
        }
export type GetAttachmentPreviewsQueryHookResult = ReturnType<typeof useGetAttachmentPreviewsQuery>;
export type GetAttachmentPreviewsLazyQueryHookResult = ReturnType<typeof useGetAttachmentPreviewsLazyQuery>;
export type GetAttachmentPreviewsSuspenseQueryHookResult = ReturnType<typeof useGetAttachmentPreviewsSuspenseQuery>;
export type GetAttachmentPreviewsQueryResult = Apollo.QueryResult<GetAttachmentPreviewsQuery, GetAttachmentPreviewsQueryVariables>;
export const UpdateMySignatureDocument = gql`
    mutation updateMySignature($values: UserDtoInput!) {
  me(input: {data: $values}) {
    success
    data {
      id
      signature
    }
  }
}
    `;
export type UpdateMySignatureMutationFn = Apollo.MutationFunction<UpdateMySignatureMutation, UpdateMySignatureMutationVariables>;

/**
 * __useUpdateMySignatureMutation__
 *
 * To run a mutation, you first call `useUpdateMySignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMySignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMySignatureMutation, { data, loading, error }] = useUpdateMySignatureMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateMySignatureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMySignatureMutation, UpdateMySignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMySignatureMutation, UpdateMySignatureMutationVariables>(UpdateMySignatureDocument, options);
      }
export type UpdateMySignatureMutationHookResult = ReturnType<typeof useUpdateMySignatureMutation>;
export type UpdateMySignatureMutationResult = Apollo.MutationResult<UpdateMySignatureMutation>;
export type UpdateMySignatureMutationOptions = Apollo.BaseMutationOptions<UpdateMySignatureMutation, UpdateMySignatureMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation deleteAttachment($attachmentId: Int!) {
  deleteAttachment(id: $attachmentId)
}
    `;
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument, options);
      }
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = Apollo.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const GetAttachmentInfoDocument = gql`
    query getAttachmentInfo($fileId: Int!) {
  attachment(id: $fileId) {
    id
    name
    extension
    cdnUri
    size
  }
}
    `;

/**
 * __useGetAttachmentInfoQuery__
 *
 * To run a query within a React component, call `useGetAttachmentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentInfoQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetAttachmentInfoQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentInfoQuery, GetAttachmentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentInfoQuery, GetAttachmentInfoQueryVariables>(GetAttachmentInfoDocument, options);
      }
export function useGetAttachmentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentInfoQuery, GetAttachmentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentInfoQuery, GetAttachmentInfoQueryVariables>(GetAttachmentInfoDocument, options);
        }
export function useGetAttachmentInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAttachmentInfoQuery, GetAttachmentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAttachmentInfoQuery, GetAttachmentInfoQueryVariables>(GetAttachmentInfoDocument, options);
        }
export type GetAttachmentInfoQueryHookResult = ReturnType<typeof useGetAttachmentInfoQuery>;
export type GetAttachmentInfoLazyQueryHookResult = ReturnType<typeof useGetAttachmentInfoLazyQuery>;
export type GetAttachmentInfoSuspenseQueryHookResult = ReturnType<typeof useGetAttachmentInfoSuspenseQuery>;
export type GetAttachmentInfoQueryResult = Apollo.QueryResult<GetAttachmentInfoQuery, GetAttachmentInfoQueryVariables>;
export const GetAttachmentsInfoDocument = gql`
    query getAttachmentsInfo($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  attachments(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      id
      name
      extension
      cdnUri
      size
    }
  }
}
    `;

/**
 * __useGetAttachmentsInfoQuery__
 *
 * To run a query within a React component, call `useGetAttachmentsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentsInfoQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAttachmentsInfoQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentsInfoQuery, GetAttachmentsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentsInfoQuery, GetAttachmentsInfoQueryVariables>(GetAttachmentsInfoDocument, options);
      }
export function useGetAttachmentsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentsInfoQuery, GetAttachmentsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentsInfoQuery, GetAttachmentsInfoQueryVariables>(GetAttachmentsInfoDocument, options);
        }
export function useGetAttachmentsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAttachmentsInfoQuery, GetAttachmentsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAttachmentsInfoQuery, GetAttachmentsInfoQueryVariables>(GetAttachmentsInfoDocument, options);
        }
export type GetAttachmentsInfoQueryHookResult = ReturnType<typeof useGetAttachmentsInfoQuery>;
export type GetAttachmentsInfoLazyQueryHookResult = ReturnType<typeof useGetAttachmentsInfoLazyQuery>;
export type GetAttachmentsInfoSuspenseQueryHookResult = ReturnType<typeof useGetAttachmentsInfoSuspenseQuery>;
export type GetAttachmentsInfoQueryResult = Apollo.QueryResult<GetAttachmentsInfoQuery, GetAttachmentsInfoQueryVariables>;
export const UpdateMeDocument = gql`
    mutation updateMe($values: UserDtoInput!) {
  me(input: {data: $values}) {
    success
    data {
      id
      lastName
      firstName
      signature
    }
  }
}
    `;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const GetUserSettingsDocument = gql`
    query getUserSettings {
  settings {
    id
    key
    value
  }
}
    `;

/**
 * __useGetUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
      }
export function useGetUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
        }
export function useGetUserSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
        }
export type GetUserSettingsQueryHookResult = ReturnType<typeof useGetUserSettingsQuery>;
export type GetUserSettingsLazyQueryHookResult = ReturnType<typeof useGetUserSettingsLazyQuery>;
export type GetUserSettingsSuspenseQueryHookResult = ReturnType<typeof useGetUserSettingsSuspenseQuery>;
export type GetUserSettingsQueryResult = Apollo.QueryResult<GetUserSettingsQuery, GetUserSettingsQueryVariables>;
export const SetSettingDocument = gql`
    mutation setSetting($key: String!, $value: String!) {
  setSetting(setting: {key: $key, value: $value}) {
    id
  }
}
    `;
export type SetSettingMutationFn = Apollo.MutationFunction<SetSettingMutation, SetSettingMutationVariables>;

/**
 * __useSetSettingMutation__
 *
 * To run a mutation, you first call `useSetSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSettingMutation, { data, loading, error }] = useSetSettingMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetSettingMutation(baseOptions?: Apollo.MutationHookOptions<SetSettingMutation, SetSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSettingMutation, SetSettingMutationVariables>(SetSettingDocument, options);
      }
export type SetSettingMutationHookResult = ReturnType<typeof useSetSettingMutation>;
export type SetSettingMutationResult = Apollo.MutationResult<SetSettingMutation>;
export type SetSettingMutationOptions = Apollo.BaseMutationOptions<SetSettingMutation, SetSettingMutationVariables>;
export const GetDriverSelectDocument = gql`
    query getDriverSelect($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  drivers(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      id
      ssn
      fleet {
        id
        name
        shortName
        legacyCompanyId
      }
      assignedCarNumber {
        driverId
        carNumber
      }
    }
  }
}
    `;

/**
 * __useGetDriverSelectQuery__
 *
 * To run a query within a React component, call `useGetDriverSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverSelectQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDriverSelectQuery(baseOptions: Apollo.QueryHookOptions<GetDriverSelectQuery, GetDriverSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverSelectQuery, GetDriverSelectQueryVariables>(GetDriverSelectDocument, options);
      }
export function useGetDriverSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverSelectQuery, GetDriverSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverSelectQuery, GetDriverSelectQueryVariables>(GetDriverSelectDocument, options);
        }
export function useGetDriverSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverSelectQuery, GetDriverSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverSelectQuery, GetDriverSelectQueryVariables>(GetDriverSelectDocument, options);
        }
export type GetDriverSelectQueryHookResult = ReturnType<typeof useGetDriverSelectQuery>;
export type GetDriverSelectLazyQueryHookResult = ReturnType<typeof useGetDriverSelectLazyQuery>;
export type GetDriverSelectSuspenseQueryHookResult = ReturnType<typeof useGetDriverSelectSuspenseQuery>;
export type GetDriverSelectQueryResult = Apollo.QueryResult<GetDriverSelectQuery, GetDriverSelectQueryVariables>;
export const GetFleetsSelectDocument = gql`
    query getFleetsSelect($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  fleets(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      id
      shortName
      name
      legacyCompanyId
    }
  }
}
    `;

/**
 * __useGetFleetsSelectQuery__
 *
 * To run a query within a React component, call `useGetFleetsSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFleetsSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFleetsSelectQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFleetsSelectQuery(baseOptions: Apollo.QueryHookOptions<GetFleetsSelectQuery, GetFleetsSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFleetsSelectQuery, GetFleetsSelectQueryVariables>(GetFleetsSelectDocument, options);
      }
export function useGetFleetsSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFleetsSelectQuery, GetFleetsSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFleetsSelectQuery, GetFleetsSelectQueryVariables>(GetFleetsSelectDocument, options);
        }
export function useGetFleetsSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFleetsSelectQuery, GetFleetsSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFleetsSelectQuery, GetFleetsSelectQueryVariables>(GetFleetsSelectDocument, options);
        }
export type GetFleetsSelectQueryHookResult = ReturnType<typeof useGetFleetsSelectQuery>;
export type GetFleetsSelectLazyQueryHookResult = ReturnType<typeof useGetFleetsSelectLazyQuery>;
export type GetFleetsSelectSuspenseQueryHookResult = ReturnType<typeof useGetFleetsSelectSuspenseQuery>;
export type GetFleetsSelectQueryResult = Apollo.QueryResult<GetFleetsSelectQuery, GetFleetsSelectQueryVariables>;
export const GetTagCategoriesSelectDocument = gql`
    query getTagCategoriesSelect($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  tagCategories(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      ...tagCategorySelectFields
    }
  }
}
    ${TagCategorySelectFieldsFragmentDoc}`;

/**
 * __useGetTagCategoriesSelectQuery__
 *
 * To run a query within a React component, call `useGetTagCategoriesSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagCategoriesSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagCategoriesSelectQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTagCategoriesSelectQuery(baseOptions: Apollo.QueryHookOptions<GetTagCategoriesSelectQuery, GetTagCategoriesSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagCategoriesSelectQuery, GetTagCategoriesSelectQueryVariables>(GetTagCategoriesSelectDocument, options);
      }
export function useGetTagCategoriesSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagCategoriesSelectQuery, GetTagCategoriesSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagCategoriesSelectQuery, GetTagCategoriesSelectQueryVariables>(GetTagCategoriesSelectDocument, options);
        }
export function useGetTagCategoriesSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagCategoriesSelectQuery, GetTagCategoriesSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagCategoriesSelectQuery, GetTagCategoriesSelectQueryVariables>(GetTagCategoriesSelectDocument, options);
        }
export type GetTagCategoriesSelectQueryHookResult = ReturnType<typeof useGetTagCategoriesSelectQuery>;
export type GetTagCategoriesSelectLazyQueryHookResult = ReturnType<typeof useGetTagCategoriesSelectLazyQuery>;
export type GetTagCategoriesSelectSuspenseQueryHookResult = ReturnType<typeof useGetTagCategoriesSelectSuspenseQuery>;
export type GetTagCategoriesSelectQueryResult = Apollo.QueryResult<GetTagCategoriesSelectQuery, GetTagCategoriesSelectQueryVariables>;
export const GetTagsSelectDocument = gql`
    query getTagsSelect($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  tags(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      ...tagSelectFields
    }
  }
}
    ${TagSelectFieldsFragmentDoc}`;

/**
 * __useGetTagsSelectQuery__
 *
 * To run a query within a React component, call `useGetTagsSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsSelectQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTagsSelectQuery(baseOptions: Apollo.QueryHookOptions<GetTagsSelectQuery, GetTagsSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsSelectQuery, GetTagsSelectQueryVariables>(GetTagsSelectDocument, options);
      }
export function useGetTagsSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsSelectQuery, GetTagsSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsSelectQuery, GetTagsSelectQueryVariables>(GetTagsSelectDocument, options);
        }
export function useGetTagsSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagsSelectQuery, GetTagsSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsSelectQuery, GetTagsSelectQueryVariables>(GetTagsSelectDocument, options);
        }
export type GetTagsSelectQueryHookResult = ReturnType<typeof useGetTagsSelectQuery>;
export type GetTagsSelectLazyQueryHookResult = ReturnType<typeof useGetTagsSelectLazyQuery>;
export type GetTagsSelectSuspenseQueryHookResult = ReturnType<typeof useGetTagsSelectSuspenseQuery>;
export type GetTagsSelectQueryResult = Apollo.QueryResult<GetTagsSelectQuery, GetTagsSelectQueryVariables>;
export const GetDriverExpirationInfoDocument = gql`
    query getDriverExpirationInfo($id: Int!) {
  driverProfile(id: $id) {
    id
    entityAttachmentPreviews {
      tagCategoryTag {
        id
        displayName
        tag {
          id
          name
        }
        sequenceOrder
      }
      attachmentId
      attachmentStatus
      attachmentExpiredAt
      expiresSoon
      required
    }
  }
}
    `;

/**
 * __useGetDriverExpirationInfoQuery__
 *
 * To run a query within a React component, call `useGetDriverExpirationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverExpirationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverExpirationInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDriverExpirationInfoQuery(baseOptions: Apollo.QueryHookOptions<GetDriverExpirationInfoQuery, GetDriverExpirationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverExpirationInfoQuery, GetDriverExpirationInfoQueryVariables>(GetDriverExpirationInfoDocument, options);
      }
export function useGetDriverExpirationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverExpirationInfoQuery, GetDriverExpirationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverExpirationInfoQuery, GetDriverExpirationInfoQueryVariables>(GetDriverExpirationInfoDocument, options);
        }
export function useGetDriverExpirationInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverExpirationInfoQuery, GetDriverExpirationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverExpirationInfoQuery, GetDriverExpirationInfoQueryVariables>(GetDriverExpirationInfoDocument, options);
        }
export type GetDriverExpirationInfoQueryHookResult = ReturnType<typeof useGetDriverExpirationInfoQuery>;
export type GetDriverExpirationInfoLazyQueryHookResult = ReturnType<typeof useGetDriverExpirationInfoLazyQuery>;
export type GetDriverExpirationInfoSuspenseQueryHookResult = ReturnType<typeof useGetDriverExpirationInfoSuspenseQuery>;
export type GetDriverExpirationInfoQueryResult = Apollo.QueryResult<GetDriverExpirationInfoQuery, GetDriverExpirationInfoQueryVariables>;
export const GetDriverTypeVerificationsDocument = gql`
    query getDriverTypeVerifications {
  verificationTypes(
    query: {page: {page: 0, size: 100}, filter: {entry: {path: "applyTo", operator: IN, value: ["Driver", "Both"]}}}
  ) {
    totalPages
    totalElements
    items {
      id
      name
      description
      systemId
    }
  }
}
    `;

/**
 * __useGetDriverTypeVerificationsQuery__
 *
 * To run a query within a React component, call `useGetDriverTypeVerificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverTypeVerificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverTypeVerificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDriverTypeVerificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetDriverTypeVerificationsQuery, GetDriverTypeVerificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverTypeVerificationsQuery, GetDriverTypeVerificationsQueryVariables>(GetDriverTypeVerificationsDocument, options);
      }
export function useGetDriverTypeVerificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverTypeVerificationsQuery, GetDriverTypeVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverTypeVerificationsQuery, GetDriverTypeVerificationsQueryVariables>(GetDriverTypeVerificationsDocument, options);
        }
export function useGetDriverTypeVerificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverTypeVerificationsQuery, GetDriverTypeVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverTypeVerificationsQuery, GetDriverTypeVerificationsQueryVariables>(GetDriverTypeVerificationsDocument, options);
        }
export type GetDriverTypeVerificationsQueryHookResult = ReturnType<typeof useGetDriverTypeVerificationsQuery>;
export type GetDriverTypeVerificationsLazyQueryHookResult = ReturnType<typeof useGetDriverTypeVerificationsLazyQuery>;
export type GetDriverTypeVerificationsSuspenseQueryHookResult = ReturnType<typeof useGetDriverTypeVerificationsSuspenseQuery>;
export type GetDriverTypeVerificationsQueryResult = Apollo.QueryResult<GetDriverTypeVerificationsQuery, GetDriverTypeVerificationsQueryVariables>;
export const GetDriverProfilesDocument = gql`
    query getDriverProfiles($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  driverProfiles(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      id
      firstName
      lastName
      driver {
        id
        authPhone {
          fullPhone
        }
        email
        latestVerifications {
          ...driverVerificationInfo
        }
      }
      carNumber
      status
      fleet {
        id
        name
        shortName
        legacyCompanyId
      }
      attachmentStatus
      entityAttachmentTotal {
        id
        nextExpirationIn
      }
      startDate
      terminationDate
      includedInLOP
      firstPaceRideDate
      latestPaceRideDate
    }
  }
}
    ${DriverVerificationInfoFragmentDoc}`;

/**
 * __useGetDriverProfilesQuery__
 *
 * To run a query within a React component, call `useGetDriverProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverProfilesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDriverProfilesQuery(baseOptions: Apollo.QueryHookOptions<GetDriverProfilesQuery, GetDriverProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverProfilesQuery, GetDriverProfilesQueryVariables>(GetDriverProfilesDocument, options);
      }
export function useGetDriverProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverProfilesQuery, GetDriverProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverProfilesQuery, GetDriverProfilesQueryVariables>(GetDriverProfilesDocument, options);
        }
export function useGetDriverProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverProfilesQuery, GetDriverProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverProfilesQuery, GetDriverProfilesQueryVariables>(GetDriverProfilesDocument, options);
        }
export type GetDriverProfilesQueryHookResult = ReturnType<typeof useGetDriverProfilesQuery>;
export type GetDriverProfilesLazyQueryHookResult = ReturnType<typeof useGetDriverProfilesLazyQuery>;
export type GetDriverProfilesSuspenseQueryHookResult = ReturnType<typeof useGetDriverProfilesSuspenseQuery>;
export type GetDriverProfilesQueryResult = Apollo.QueryResult<GetDriverProfilesQuery, GetDriverProfilesQueryVariables>;
export const GetEntityAttachmentsPreviewDownloadDocument = gql`
    query getEntityAttachmentsPreviewDownload($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  entityAttachmentPreviews(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      attachmentStatus
      driver {
        id
      }
      driverProfile {
        id
        includedInLOP
        startDate
        fullName
      }
      fleet {
        id
        name
        shortName
        legacyCompanyId
      }
      tagCategory {
        id
        name
      }
      tag {
        id
        name
      }
      attachment {
        id
        name
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetEntityAttachmentsPreviewDownloadQuery__
 *
 * To run a query within a React component, call `useGetEntityAttachmentsPreviewDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityAttachmentsPreviewDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityAttachmentsPreviewDownloadQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEntityAttachmentsPreviewDownloadQuery(baseOptions: Apollo.QueryHookOptions<GetEntityAttachmentsPreviewDownloadQuery, GetEntityAttachmentsPreviewDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityAttachmentsPreviewDownloadQuery, GetEntityAttachmentsPreviewDownloadQueryVariables>(GetEntityAttachmentsPreviewDownloadDocument, options);
      }
export function useGetEntityAttachmentsPreviewDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityAttachmentsPreviewDownloadQuery, GetEntityAttachmentsPreviewDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityAttachmentsPreviewDownloadQuery, GetEntityAttachmentsPreviewDownloadQueryVariables>(GetEntityAttachmentsPreviewDownloadDocument, options);
        }
export function useGetEntityAttachmentsPreviewDownloadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEntityAttachmentsPreviewDownloadQuery, GetEntityAttachmentsPreviewDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityAttachmentsPreviewDownloadQuery, GetEntityAttachmentsPreviewDownloadQueryVariables>(GetEntityAttachmentsPreviewDownloadDocument, options);
        }
export type GetEntityAttachmentsPreviewDownloadQueryHookResult = ReturnType<typeof useGetEntityAttachmentsPreviewDownloadQuery>;
export type GetEntityAttachmentsPreviewDownloadLazyQueryHookResult = ReturnType<typeof useGetEntityAttachmentsPreviewDownloadLazyQuery>;
export type GetEntityAttachmentsPreviewDownloadSuspenseQueryHookResult = ReturnType<typeof useGetEntityAttachmentsPreviewDownloadSuspenseQuery>;
export type GetEntityAttachmentsPreviewDownloadQueryResult = Apollo.QueryResult<GetEntityAttachmentsPreviewDownloadQuery, GetEntityAttachmentsPreviewDownloadQueryVariables>;
export const GetEntityAttachmentsPreviewDownloadLinksDocument = gql`
    query getEntityAttachmentsPreviewDownloadLinks($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  entityAttachmentPreviews(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      driver {
        id
      }
      driverProfile {
        id
        lastName
        firstName
      }
      fleet {
        id
        name
        shortName
        legacyCompanyId
      }
      attachment {
        id
        name
        cdnUri
        size
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetEntityAttachmentsPreviewDownloadLinksQuery__
 *
 * To run a query within a React component, call `useGetEntityAttachmentsPreviewDownloadLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityAttachmentsPreviewDownloadLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityAttachmentsPreviewDownloadLinksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEntityAttachmentsPreviewDownloadLinksQuery(baseOptions: Apollo.QueryHookOptions<GetEntityAttachmentsPreviewDownloadLinksQuery, GetEntityAttachmentsPreviewDownloadLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityAttachmentsPreviewDownloadLinksQuery, GetEntityAttachmentsPreviewDownloadLinksQueryVariables>(GetEntityAttachmentsPreviewDownloadLinksDocument, options);
      }
export function useGetEntityAttachmentsPreviewDownloadLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityAttachmentsPreviewDownloadLinksQuery, GetEntityAttachmentsPreviewDownloadLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityAttachmentsPreviewDownloadLinksQuery, GetEntityAttachmentsPreviewDownloadLinksQueryVariables>(GetEntityAttachmentsPreviewDownloadLinksDocument, options);
        }
export function useGetEntityAttachmentsPreviewDownloadLinksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEntityAttachmentsPreviewDownloadLinksQuery, GetEntityAttachmentsPreviewDownloadLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityAttachmentsPreviewDownloadLinksQuery, GetEntityAttachmentsPreviewDownloadLinksQueryVariables>(GetEntityAttachmentsPreviewDownloadLinksDocument, options);
        }
export type GetEntityAttachmentsPreviewDownloadLinksQueryHookResult = ReturnType<typeof useGetEntityAttachmentsPreviewDownloadLinksQuery>;
export type GetEntityAttachmentsPreviewDownloadLinksLazyQueryHookResult = ReturnType<typeof useGetEntityAttachmentsPreviewDownloadLinksLazyQuery>;
export type GetEntityAttachmentsPreviewDownloadLinksSuspenseQueryHookResult = ReturnType<typeof useGetEntityAttachmentsPreviewDownloadLinksSuspenseQuery>;
export type GetEntityAttachmentsPreviewDownloadLinksQueryResult = Apollo.QueryResult<GetEntityAttachmentsPreviewDownloadLinksQuery, GetEntityAttachmentsPreviewDownloadLinksQueryVariables>;
export const GetEntityAttachmentsPreviewDocument = gql`
    query getEntityAttachmentsPreview($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  entityAttachmentPreviews(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: {expr: {operator: AND, children: [{entry: {path: "fleet.portalUsers.id", operator: NOT_NULL}}, {entry: {path: "tag.attachmentRequestAllowed", operator: EQUAL, value: true}}, $filter]}}}
  ) {
    totalPages
    totalElements
    items {
      driverProfileId
      driver {
        id
        email
      }
      driverProfile {
        id
        fullName
      }
      fleet {
        id
        name
        shortName
        legacyCompanyId
        companyRepresentativeUser {
          id
          email
        }
      }
      tagCategory {
        id
        name
      }
      tag {
        id
        name
      }
      attachmentStatus
      expiresSoon
      attachment {
        id
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetEntityAttachmentsPreviewQuery__
 *
 * To run a query within a React component, call `useGetEntityAttachmentsPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityAttachmentsPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityAttachmentsPreviewQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEntityAttachmentsPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetEntityAttachmentsPreviewQuery, GetEntityAttachmentsPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityAttachmentsPreviewQuery, GetEntityAttachmentsPreviewQueryVariables>(GetEntityAttachmentsPreviewDocument, options);
      }
export function useGetEntityAttachmentsPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityAttachmentsPreviewQuery, GetEntityAttachmentsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityAttachmentsPreviewQuery, GetEntityAttachmentsPreviewQueryVariables>(GetEntityAttachmentsPreviewDocument, options);
        }
export function useGetEntityAttachmentsPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEntityAttachmentsPreviewQuery, GetEntityAttachmentsPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityAttachmentsPreviewQuery, GetEntityAttachmentsPreviewQueryVariables>(GetEntityAttachmentsPreviewDocument, options);
        }
export type GetEntityAttachmentsPreviewQueryHookResult = ReturnType<typeof useGetEntityAttachmentsPreviewQuery>;
export type GetEntityAttachmentsPreviewLazyQueryHookResult = ReturnType<typeof useGetEntityAttachmentsPreviewLazyQuery>;
export type GetEntityAttachmentsPreviewSuspenseQueryHookResult = ReturnType<typeof useGetEntityAttachmentsPreviewSuspenseQuery>;
export type GetEntityAttachmentsPreviewQueryResult = Apollo.QueryResult<GetEntityAttachmentsPreviewQuery, GetEntityAttachmentsPreviewQueryVariables>;
export const SetDriverProfileIncludedToLopStatusDocument = gql`
    mutation setDriverProfileIncludedToLOPStatus($filter: FilterExpressionChildInput, $status: IncludedInLOPStatus!) {
  setDriverProfileIncludedToLOPStatus(
    update: {filter: $filter}
    includedInLOP: $status
  )
}
    `;
export type SetDriverProfileIncludedToLopStatusMutationFn = Apollo.MutationFunction<SetDriverProfileIncludedToLopStatusMutation, SetDriverProfileIncludedToLopStatusMutationVariables>;

/**
 * __useSetDriverProfileIncludedToLopStatusMutation__
 *
 * To run a mutation, you first call `useSetDriverProfileIncludedToLopStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDriverProfileIncludedToLopStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDriverProfileIncludedToLopStatusMutation, { data, loading, error }] = useSetDriverProfileIncludedToLopStatusMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetDriverProfileIncludedToLopStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetDriverProfileIncludedToLopStatusMutation, SetDriverProfileIncludedToLopStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDriverProfileIncludedToLopStatusMutation, SetDriverProfileIncludedToLopStatusMutationVariables>(SetDriverProfileIncludedToLopStatusDocument, options);
      }
export type SetDriverProfileIncludedToLopStatusMutationHookResult = ReturnType<typeof useSetDriverProfileIncludedToLopStatusMutation>;
export type SetDriverProfileIncludedToLopStatusMutationResult = Apollo.MutationResult<SetDriverProfileIncludedToLopStatusMutation>;
export type SetDriverProfileIncludedToLopStatusMutationOptions = Apollo.BaseMutationOptions<SetDriverProfileIncludedToLopStatusMutation, SetDriverProfileIncludedToLopStatusMutationVariables>;
export const GetDriverProfilesForLopDocument = gql`
    query getDriverProfilesForLOP($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  driverProfiles(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      id
      firstName
      lastName
      fleet {
        id
        name
        shortName
        legacyCompanyId
      }
      driver {
        id
      }
      startDate
      terminationDate
    }
  }
}
    `;

/**
 * __useGetDriverProfilesForLopQuery__
 *
 * To run a query within a React component, call `useGetDriverProfilesForLopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverProfilesForLopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverProfilesForLopQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDriverProfilesForLopQuery(baseOptions: Apollo.QueryHookOptions<GetDriverProfilesForLopQuery, GetDriverProfilesForLopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverProfilesForLopQuery, GetDriverProfilesForLopQueryVariables>(GetDriverProfilesForLopDocument, options);
      }
export function useGetDriverProfilesForLopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverProfilesForLopQuery, GetDriverProfilesForLopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverProfilesForLopQuery, GetDriverProfilesForLopQueryVariables>(GetDriverProfilesForLopDocument, options);
        }
export function useGetDriverProfilesForLopSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverProfilesForLopQuery, GetDriverProfilesForLopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverProfilesForLopQuery, GetDriverProfilesForLopQueryVariables>(GetDriverProfilesForLopDocument, options);
        }
export type GetDriverProfilesForLopQueryHookResult = ReturnType<typeof useGetDriverProfilesForLopQuery>;
export type GetDriverProfilesForLopLazyQueryHookResult = ReturnType<typeof useGetDriverProfilesForLopLazyQuery>;
export type GetDriverProfilesForLopSuspenseQueryHookResult = ReturnType<typeof useGetDriverProfilesForLopSuspenseQuery>;
export type GetDriverProfilesForLopQueryResult = Apollo.QueryResult<GetDriverProfilesForLopQuery, GetDriverProfilesForLopQueryVariables>;
export const GetDriverProfilesCountDocument = gql`
    query getDriverProfilesCount($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  driverProfiles(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: {expr: {operator: AND, children: [$filter, {entry: {path: "isActive", operator: EQUAL, value: true}}]}}}
  ) {
    totalElements
  }
}
    `;

/**
 * __useGetDriverProfilesCountQuery__
 *
 * To run a query within a React component, call `useGetDriverProfilesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverProfilesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverProfilesCountQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDriverProfilesCountQuery(baseOptions: Apollo.QueryHookOptions<GetDriverProfilesCountQuery, GetDriverProfilesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverProfilesCountQuery, GetDriverProfilesCountQueryVariables>(GetDriverProfilesCountDocument, options);
      }
export function useGetDriverProfilesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverProfilesCountQuery, GetDriverProfilesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverProfilesCountQuery, GetDriverProfilesCountQueryVariables>(GetDriverProfilesCountDocument, options);
        }
export function useGetDriverProfilesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverProfilesCountQuery, GetDriverProfilesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverProfilesCountQuery, GetDriverProfilesCountQueryVariables>(GetDriverProfilesCountDocument, options);
        }
export type GetDriverProfilesCountQueryHookResult = ReturnType<typeof useGetDriverProfilesCountQuery>;
export type GetDriverProfilesCountLazyQueryHookResult = ReturnType<typeof useGetDriverProfilesCountLazyQuery>;
export type GetDriverProfilesCountSuspenseQueryHookResult = ReturnType<typeof useGetDriverProfilesCountSuspenseQuery>;
export type GetDriverProfilesCountQueryResult = Apollo.QueryResult<GetDriverProfilesCountQuery, GetDriverProfilesCountQueryVariables>;
export const TerminateProfileDocument = gql`
    mutation terminateProfile($id: Int) {
  deactivateProfile(id: $id) {
    success
  }
}
    `;
export type TerminateProfileMutationFn = Apollo.MutationFunction<TerminateProfileMutation, TerminateProfileMutationVariables>;

/**
 * __useTerminateProfileMutation__
 *
 * To run a mutation, you first call `useTerminateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateProfileMutation, { data, loading, error }] = useTerminateProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTerminateProfileMutation(baseOptions?: Apollo.MutationHookOptions<TerminateProfileMutation, TerminateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminateProfileMutation, TerminateProfileMutationVariables>(TerminateProfileDocument, options);
      }
export type TerminateProfileMutationHookResult = ReturnType<typeof useTerminateProfileMutation>;
export type TerminateProfileMutationResult = Apollo.MutationResult<TerminateProfileMutation>;
export type TerminateProfileMutationOptions = Apollo.BaseMutationOptions<TerminateProfileMutation, TerminateProfileMutationVariables>;
export const ReevaluateDocumentStatusDocument = gql`
    mutation reevaluateDocumentStatus($id: Int) {
  updateDocumentStatus(id: $id) {
    success
  }
}
    `;
export type ReevaluateDocumentStatusMutationFn = Apollo.MutationFunction<ReevaluateDocumentStatusMutation, ReevaluateDocumentStatusMutationVariables>;

/**
 * __useReevaluateDocumentStatusMutation__
 *
 * To run a mutation, you first call `useReevaluateDocumentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReevaluateDocumentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reevaluateDocumentStatusMutation, { data, loading, error }] = useReevaluateDocumentStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReevaluateDocumentStatusMutation(baseOptions?: Apollo.MutationHookOptions<ReevaluateDocumentStatusMutation, ReevaluateDocumentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReevaluateDocumentStatusMutation, ReevaluateDocumentStatusMutationVariables>(ReevaluateDocumentStatusDocument, options);
      }
export type ReevaluateDocumentStatusMutationHookResult = ReturnType<typeof useReevaluateDocumentStatusMutation>;
export type ReevaluateDocumentStatusMutationResult = Apollo.MutationResult<ReevaluateDocumentStatusMutation>;
export type ReevaluateDocumentStatusMutationOptions = Apollo.BaseMutationOptions<ReevaluateDocumentStatusMutation, ReevaluateDocumentStatusMutationVariables>;
export const ReactivateProfileDocument = gql`
    mutation reactivateProfile($id: Int) {
  reactivateProfile(id: $id) {
    success
    data {
      id
    }
  }
}
    `;
export type ReactivateProfileMutationFn = Apollo.MutationFunction<ReactivateProfileMutation, ReactivateProfileMutationVariables>;

/**
 * __useReactivateProfileMutation__
 *
 * To run a mutation, you first call `useReactivateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateProfileMutation, { data, loading, error }] = useReactivateProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateProfileMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateProfileMutation, ReactivateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateProfileMutation, ReactivateProfileMutationVariables>(ReactivateProfileDocument, options);
      }
export type ReactivateProfileMutationHookResult = ReturnType<typeof useReactivateProfileMutation>;
export type ReactivateProfileMutationResult = Apollo.MutationResult<ReactivateProfileMutation>;
export type ReactivateProfileMutationOptions = Apollo.BaseMutationOptions<ReactivateProfileMutation, ReactivateProfileMutationVariables>;
export const AppendAttachmentToDriverProfileDocument = gql`
    mutation appendAttachmentToDriverProfile($driverProfileId: Int!, $values: AttachmentDtoInput!) {
  appendAttachmentToDriverProfile(
    driverProfileId: $driverProfileId
    input: {data: $values}
  ) {
    success
  }
}
    `;
export type AppendAttachmentToDriverProfileMutationFn = Apollo.MutationFunction<AppendAttachmentToDriverProfileMutation, AppendAttachmentToDriverProfileMutationVariables>;

/**
 * __useAppendAttachmentToDriverProfileMutation__
 *
 * To run a mutation, you first call `useAppendAttachmentToDriverProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendAttachmentToDriverProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendAttachmentToDriverProfileMutation, { data, loading, error }] = useAppendAttachmentToDriverProfileMutation({
 *   variables: {
 *      driverProfileId: // value for 'driverProfileId'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useAppendAttachmentToDriverProfileMutation(baseOptions?: Apollo.MutationHookOptions<AppendAttachmentToDriverProfileMutation, AppendAttachmentToDriverProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendAttachmentToDriverProfileMutation, AppendAttachmentToDriverProfileMutationVariables>(AppendAttachmentToDriverProfileDocument, options);
      }
export type AppendAttachmentToDriverProfileMutationHookResult = ReturnType<typeof useAppendAttachmentToDriverProfileMutation>;
export type AppendAttachmentToDriverProfileMutationResult = Apollo.MutationResult<AppendAttachmentToDriverProfileMutation>;
export type AppendAttachmentToDriverProfileMutationOptions = Apollo.BaseMutationOptions<AppendAttachmentToDriverProfileMutation, AppendAttachmentToDriverProfileMutationVariables>;
export const RegisterDriverProfileAttachmentRequestDocument = gql`
    mutation registerDriverProfileAttachmentRequest($driverProfileId: Int!, $tagId: Int!, $email: String!) {
  registerDriverProfileAttachmentRequest(
    driverProfileId: $driverProfileId
    tagId: $tagId
    email: $email
  )
}
    `;
export type RegisterDriverProfileAttachmentRequestMutationFn = Apollo.MutationFunction<RegisterDriverProfileAttachmentRequestMutation, RegisterDriverProfileAttachmentRequestMutationVariables>;

/**
 * __useRegisterDriverProfileAttachmentRequestMutation__
 *
 * To run a mutation, you first call `useRegisterDriverProfileAttachmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDriverProfileAttachmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerDriverProfileAttachmentRequestMutation, { data, loading, error }] = useRegisterDriverProfileAttachmentRequestMutation({
 *   variables: {
 *      driverProfileId: // value for 'driverProfileId'
 *      tagId: // value for 'tagId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRegisterDriverProfileAttachmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<RegisterDriverProfileAttachmentRequestMutation, RegisterDriverProfileAttachmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterDriverProfileAttachmentRequestMutation, RegisterDriverProfileAttachmentRequestMutationVariables>(RegisterDriverProfileAttachmentRequestDocument, options);
      }
export type RegisterDriverProfileAttachmentRequestMutationHookResult = ReturnType<typeof useRegisterDriverProfileAttachmentRequestMutation>;
export type RegisterDriverProfileAttachmentRequestMutationResult = Apollo.MutationResult<RegisterDriverProfileAttachmentRequestMutation>;
export type RegisterDriverProfileAttachmentRequestMutationOptions = Apollo.BaseMutationOptions<RegisterDriverProfileAttachmentRequestMutation, RegisterDriverProfileAttachmentRequestMutationVariables>;
export const SaveDriverSignatureDocument = gql`
    mutation saveDriverSignature($driverId: Int!, $signature: ObjectScalar!) {
  setDriverSignature(driverId: $driverId, signature: $signature) {
    id
  }
}
    `;
export type SaveDriverSignatureMutationFn = Apollo.MutationFunction<SaveDriverSignatureMutation, SaveDriverSignatureMutationVariables>;

/**
 * __useSaveDriverSignatureMutation__
 *
 * To run a mutation, you first call `useSaveDriverSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDriverSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDriverSignatureMutation, { data, loading, error }] = useSaveDriverSignatureMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useSaveDriverSignatureMutation(baseOptions?: Apollo.MutationHookOptions<SaveDriverSignatureMutation, SaveDriverSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDriverSignatureMutation, SaveDriverSignatureMutationVariables>(SaveDriverSignatureDocument, options);
      }
export type SaveDriverSignatureMutationHookResult = ReturnType<typeof useSaveDriverSignatureMutation>;
export type SaveDriverSignatureMutationResult = Apollo.MutationResult<SaveDriverSignatureMutation>;
export type SaveDriverSignatureMutationOptions = Apollo.BaseMutationOptions<SaveDriverSignatureMutation, SaveDriverSignatureMutationVariables>;
export const GetDriverProfileDocument = gql`
    query getDriverProfile($id: Int) {
  driverProfile(id: $id) {
    ...driverProfileForm
  }
}
    ${DriverProfileFormFragmentDoc}`;

/**
 * __useGetDriverProfileQuery__
 *
 * To run a query within a React component, call `useGetDriverProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDriverProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetDriverProfileQuery, GetDriverProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverProfileQuery, GetDriverProfileQueryVariables>(GetDriverProfileDocument, options);
      }
export function useGetDriverProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverProfileQuery, GetDriverProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverProfileQuery, GetDriverProfileQueryVariables>(GetDriverProfileDocument, options);
        }
export function useGetDriverProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverProfileQuery, GetDriverProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverProfileQuery, GetDriverProfileQueryVariables>(GetDriverProfileDocument, options);
        }
export type GetDriverProfileQueryHookResult = ReturnType<typeof useGetDriverProfileQuery>;
export type GetDriverProfileLazyQueryHookResult = ReturnType<typeof useGetDriverProfileLazyQuery>;
export type GetDriverProfileSuspenseQueryHookResult = ReturnType<typeof useGetDriverProfileSuspenseQuery>;
export type GetDriverProfileQueryResult = Apollo.QueryResult<GetDriverProfileQuery, GetDriverProfileQueryVariables>;
export const UpdateDriverProfileDocument = gql`
    mutation updateDriverProfile($values: DriverProfileDtoInput!) {
  updateDriverProfile(input: {data: $values}) {
    success
    data {
      ...driverProfileForm
    }
  }
}
    ${DriverProfileFormFragmentDoc}`;
export type UpdateDriverProfileMutationFn = Apollo.MutationFunction<UpdateDriverProfileMutation, UpdateDriverProfileMutationVariables>;

/**
 * __useUpdateDriverProfileMutation__
 *
 * To run a mutation, you first call `useUpdateDriverProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverProfileMutation, { data, loading, error }] = useUpdateDriverProfileMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateDriverProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverProfileMutation, UpdateDriverProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverProfileMutation, UpdateDriverProfileMutationVariables>(UpdateDriverProfileDocument, options);
      }
export type UpdateDriverProfileMutationHookResult = ReturnType<typeof useUpdateDriverProfileMutation>;
export type UpdateDriverProfileMutationResult = Apollo.MutationResult<UpdateDriverProfileMutation>;
export type UpdateDriverProfileMutationOptions = Apollo.BaseMutationOptions<UpdateDriverProfileMutation, UpdateDriverProfileMutationVariables>;
export const GetFleetsDocument = gql`
    query getFleets($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  fleets(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      id
      legacyCompanyId
      name
      shortName
      latestVerifications {
        ...fleetVerificationInfo
        verificationType {
          description
        }
      }
    }
  }
}
    ${FleetVerificationInfoFragmentDoc}`;

/**
 * __useGetFleetsQuery__
 *
 * To run a query within a React component, call `useGetFleetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFleetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFleetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFleetsQuery(baseOptions: Apollo.QueryHookOptions<GetFleetsQuery, GetFleetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFleetsQuery, GetFleetsQueryVariables>(GetFleetsDocument, options);
      }
export function useGetFleetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFleetsQuery, GetFleetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFleetsQuery, GetFleetsQueryVariables>(GetFleetsDocument, options);
        }
export function useGetFleetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFleetsQuery, GetFleetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFleetsQuery, GetFleetsQueryVariables>(GetFleetsDocument, options);
        }
export type GetFleetsQueryHookResult = ReturnType<typeof useGetFleetsQuery>;
export type GetFleetsLazyQueryHookResult = ReturnType<typeof useGetFleetsLazyQuery>;
export type GetFleetsSuspenseQueryHookResult = ReturnType<typeof useGetFleetsSuspenseQuery>;
export type GetFleetsQueryResult = Apollo.QueryResult<GetFleetsQuery, GetFleetsQueryVariables>;
export const GetAffiliateTypeVerificationsDocument = gql`
    query getAffiliateTypeVerifications {
  verificationTypes(
    query: {page: {page: 0, size: 100}, filter: {entry: {path: "applyTo", operator: IN, value: ["Affiliate", "Both"]}}}
  ) {
    totalPages
    totalElements
    items {
      id
      name
      description
      systemId
    }
  }
}
    `;

/**
 * __useGetAffiliateTypeVerificationsQuery__
 *
 * To run a query within a React component, call `useGetAffiliateTypeVerificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffiliateTypeVerificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffiliateTypeVerificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAffiliateTypeVerificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAffiliateTypeVerificationsQuery, GetAffiliateTypeVerificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAffiliateTypeVerificationsQuery, GetAffiliateTypeVerificationsQueryVariables>(GetAffiliateTypeVerificationsDocument, options);
      }
export function useGetAffiliateTypeVerificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAffiliateTypeVerificationsQuery, GetAffiliateTypeVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAffiliateTypeVerificationsQuery, GetAffiliateTypeVerificationsQueryVariables>(GetAffiliateTypeVerificationsDocument, options);
        }
export function useGetAffiliateTypeVerificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAffiliateTypeVerificationsQuery, GetAffiliateTypeVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAffiliateTypeVerificationsQuery, GetAffiliateTypeVerificationsQueryVariables>(GetAffiliateTypeVerificationsDocument, options);
        }
export type GetAffiliateTypeVerificationsQueryHookResult = ReturnType<typeof useGetAffiliateTypeVerificationsQuery>;
export type GetAffiliateTypeVerificationsLazyQueryHookResult = ReturnType<typeof useGetAffiliateTypeVerificationsLazyQuery>;
export type GetAffiliateTypeVerificationsSuspenseQueryHookResult = ReturnType<typeof useGetAffiliateTypeVerificationsSuspenseQuery>;
export type GetAffiliateTypeVerificationsQueryResult = Apollo.QueryResult<GetAffiliateTypeVerificationsQuery, GetAffiliateTypeVerificationsQueryVariables>;
export const GetFleetsCountDocument = gql`
    query getFleetsCount($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  fleets(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalElements
  }
}
    `;

/**
 * __useGetFleetsCountQuery__
 *
 * To run a query within a React component, call `useGetFleetsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFleetsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFleetsCountQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFleetsCountQuery(baseOptions: Apollo.QueryHookOptions<GetFleetsCountQuery, GetFleetsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFleetsCountQuery, GetFleetsCountQueryVariables>(GetFleetsCountDocument, options);
      }
export function useGetFleetsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFleetsCountQuery, GetFleetsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFleetsCountQuery, GetFleetsCountQueryVariables>(GetFleetsCountDocument, options);
        }
export function useGetFleetsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFleetsCountQuery, GetFleetsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFleetsCountQuery, GetFleetsCountQueryVariables>(GetFleetsCountDocument, options);
        }
export type GetFleetsCountQueryHookResult = ReturnType<typeof useGetFleetsCountQuery>;
export type GetFleetsCountLazyQueryHookResult = ReturnType<typeof useGetFleetsCountLazyQuery>;
export type GetFleetsCountSuspenseQueryHookResult = ReturnType<typeof useGetFleetsCountSuspenseQuery>;
export type GetFleetsCountQueryResult = Apollo.QueryResult<GetFleetsCountQuery, GetFleetsCountQueryVariables>;
export const AppendAttachmentToFleetDocument = gql`
    mutation appendAttachmentToFleet($fleetId: Int!, $values: AttachmentDtoInput!) {
  appendAttachmentToFleet(fleetId: $fleetId, input: {data: $values}) {
    success
  }
}
    `;
export type AppendAttachmentToFleetMutationFn = Apollo.MutationFunction<AppendAttachmentToFleetMutation, AppendAttachmentToFleetMutationVariables>;

/**
 * __useAppendAttachmentToFleetMutation__
 *
 * To run a mutation, you first call `useAppendAttachmentToFleetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendAttachmentToFleetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendAttachmentToFleetMutation, { data, loading, error }] = useAppendAttachmentToFleetMutation({
 *   variables: {
 *      fleetId: // value for 'fleetId'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useAppendAttachmentToFleetMutation(baseOptions?: Apollo.MutationHookOptions<AppendAttachmentToFleetMutation, AppendAttachmentToFleetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendAttachmentToFleetMutation, AppendAttachmentToFleetMutationVariables>(AppendAttachmentToFleetDocument, options);
      }
export type AppendAttachmentToFleetMutationHookResult = ReturnType<typeof useAppendAttachmentToFleetMutation>;
export type AppendAttachmentToFleetMutationResult = Apollo.MutationResult<AppendAttachmentToFleetMutation>;
export type AppendAttachmentToFleetMutationOptions = Apollo.BaseMutationOptions<AppendAttachmentToFleetMutation, AppendAttachmentToFleetMutationVariables>;
export const RegisterFleetAttachmentRequestDocument = gql`
    mutation registerFleetAttachmentRequest($fleetId: Int!, $tagId: Int!, $email: String!) {
  registerFleetAttachmentRequest(fleetId: $fleetId, tagId: $tagId, email: $email)
}
    `;
export type RegisterFleetAttachmentRequestMutationFn = Apollo.MutationFunction<RegisterFleetAttachmentRequestMutation, RegisterFleetAttachmentRequestMutationVariables>;

/**
 * __useRegisterFleetAttachmentRequestMutation__
 *
 * To run a mutation, you first call `useRegisterFleetAttachmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterFleetAttachmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerFleetAttachmentRequestMutation, { data, loading, error }] = useRegisterFleetAttachmentRequestMutation({
 *   variables: {
 *      fleetId: // value for 'fleetId'
 *      tagId: // value for 'tagId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRegisterFleetAttachmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<RegisterFleetAttachmentRequestMutation, RegisterFleetAttachmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterFleetAttachmentRequestMutation, RegisterFleetAttachmentRequestMutationVariables>(RegisterFleetAttachmentRequestDocument, options);
      }
export type RegisterFleetAttachmentRequestMutationHookResult = ReturnType<typeof useRegisterFleetAttachmentRequestMutation>;
export type RegisterFleetAttachmentRequestMutationResult = Apollo.MutationResult<RegisterFleetAttachmentRequestMutation>;
export type RegisterFleetAttachmentRequestMutationOptions = Apollo.BaseMutationOptions<RegisterFleetAttachmentRequestMutation, RegisterFleetAttachmentRequestMutationVariables>;
export const InviteUserDocument = gql`
    mutation inviteUser($values: InviteUserDtoInput!) {
  inviteManager(input: {data: $values}) {
    success
    data {
      id
      lastName
      firstName
      email
    }
  }
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const GetFleetDocument = gql`
    query getFleet($id: Int) {
  fleet(id: $id) {
    ...fleetForm
  }
}
    ${FleetFormFragmentDoc}`;

/**
 * __useGetFleetQuery__
 *
 * To run a query within a React component, call `useGetFleetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFleetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFleetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFleetQuery(baseOptions?: Apollo.QueryHookOptions<GetFleetQuery, GetFleetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFleetQuery, GetFleetQueryVariables>(GetFleetDocument, options);
      }
export function useGetFleetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFleetQuery, GetFleetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFleetQuery, GetFleetQueryVariables>(GetFleetDocument, options);
        }
export function useGetFleetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFleetQuery, GetFleetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFleetQuery, GetFleetQueryVariables>(GetFleetDocument, options);
        }
export type GetFleetQueryHookResult = ReturnType<typeof useGetFleetQuery>;
export type GetFleetLazyQueryHookResult = ReturnType<typeof useGetFleetLazyQuery>;
export type GetFleetSuspenseQueryHookResult = ReturnType<typeof useGetFleetSuspenseQuery>;
export type GetFleetQueryResult = Apollo.QueryResult<GetFleetQuery, GetFleetQueryVariables>;
export const UpdateFleetDocument = gql`
    mutation updateFleet($values: FleetDtoInput!) {
  updateFleet(input: {data: $values}) {
    success
    data {
      ...fleetForm
    }
  }
}
    ${FleetFormFragmentDoc}`;
export type UpdateFleetMutationFn = Apollo.MutationFunction<UpdateFleetMutation, UpdateFleetMutationVariables>;

/**
 * __useUpdateFleetMutation__
 *
 * To run a mutation, you first call `useUpdateFleetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFleetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFleetMutation, { data, loading, error }] = useUpdateFleetMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateFleetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFleetMutation, UpdateFleetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFleetMutation, UpdateFleetMutationVariables>(UpdateFleetDocument, options);
      }
export type UpdateFleetMutationHookResult = ReturnType<typeof useUpdateFleetMutation>;
export type UpdateFleetMutationResult = Apollo.MutationResult<UpdateFleetMutation>;
export type UpdateFleetMutationOptions = Apollo.BaseMutationOptions<UpdateFleetMutation, UpdateFleetMutationVariables>;
export const GetTagCategoriesDocument = gql`
    query getTagCategories($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  tagCategories(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      id
      name
      description
      updatedAt
      updatedByUser {
        id
        username
        email
      }
    }
  }
}
    `;

/**
 * __useGetTagCategoriesQuery__
 *
 * To run a query within a React component, call `useGetTagCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTagCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetTagCategoriesQuery, GetTagCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagCategoriesQuery, GetTagCategoriesQueryVariables>(GetTagCategoriesDocument, options);
      }
export function useGetTagCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagCategoriesQuery, GetTagCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagCategoriesQuery, GetTagCategoriesQueryVariables>(GetTagCategoriesDocument, options);
        }
export function useGetTagCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagCategoriesQuery, GetTagCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagCategoriesQuery, GetTagCategoriesQueryVariables>(GetTagCategoriesDocument, options);
        }
export type GetTagCategoriesQueryHookResult = ReturnType<typeof useGetTagCategoriesQuery>;
export type GetTagCategoriesLazyQueryHookResult = ReturnType<typeof useGetTagCategoriesLazyQuery>;
export type GetTagCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetTagCategoriesSuspenseQuery>;
export type GetTagCategoriesQueryResult = Apollo.QueryResult<GetTagCategoriesQuery, GetTagCategoriesQueryVariables>;
export const GetTagCategoryDocument = gql`
    query getTagCategory($id: Int) {
  tagCategory(id: $id) {
    ...tagCategoryForm
  }
}
    ${TagCategoryFormFragmentDoc}`;

/**
 * __useGetTagCategoryQuery__
 *
 * To run a query within a React component, call `useGetTagCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTagCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetTagCategoryQuery, GetTagCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagCategoryQuery, GetTagCategoryQueryVariables>(GetTagCategoryDocument, options);
      }
export function useGetTagCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagCategoryQuery, GetTagCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagCategoryQuery, GetTagCategoryQueryVariables>(GetTagCategoryDocument, options);
        }
export function useGetTagCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagCategoryQuery, GetTagCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagCategoryQuery, GetTagCategoryQueryVariables>(GetTagCategoryDocument, options);
        }
export type GetTagCategoryQueryHookResult = ReturnType<typeof useGetTagCategoryQuery>;
export type GetTagCategoryLazyQueryHookResult = ReturnType<typeof useGetTagCategoryLazyQuery>;
export type GetTagCategorySuspenseQueryHookResult = ReturnType<typeof useGetTagCategorySuspenseQuery>;
export type GetTagCategoryQueryResult = Apollo.QueryResult<GetTagCategoryQuery, GetTagCategoryQueryVariables>;
export const CreateTagCategoryDocument = gql`
    mutation createTagCategory($values: TagCategoryDtoInput!) {
  createTagCategory(input: {data: $values}) {
    success
    data {
      ...tagCategoryForm
    }
  }
}
    ${TagCategoryFormFragmentDoc}`;
export type CreateTagCategoryMutationFn = Apollo.MutationFunction<CreateTagCategoryMutation, CreateTagCategoryMutationVariables>;

/**
 * __useCreateTagCategoryMutation__
 *
 * To run a mutation, you first call `useCreateTagCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagCategoryMutation, { data, loading, error }] = useCreateTagCategoryMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateTagCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagCategoryMutation, CreateTagCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagCategoryMutation, CreateTagCategoryMutationVariables>(CreateTagCategoryDocument, options);
      }
export type CreateTagCategoryMutationHookResult = ReturnType<typeof useCreateTagCategoryMutation>;
export type CreateTagCategoryMutationResult = Apollo.MutationResult<CreateTagCategoryMutation>;
export type CreateTagCategoryMutationOptions = Apollo.BaseMutationOptions<CreateTagCategoryMutation, CreateTagCategoryMutationVariables>;
export const UpdateTagCategoryDocument = gql`
    mutation updateTagCategory($values: TagCategoryDtoInput!) {
  updateTagCategory(input: {data: $values}) {
    success
    data {
      ...tagCategoryForm
    }
  }
}
    ${TagCategoryFormFragmentDoc}`;
export type UpdateTagCategoryMutationFn = Apollo.MutationFunction<UpdateTagCategoryMutation, UpdateTagCategoryMutationVariables>;

/**
 * __useUpdateTagCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateTagCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagCategoryMutation, { data, loading, error }] = useUpdateTagCategoryMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateTagCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagCategoryMutation, UpdateTagCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagCategoryMutation, UpdateTagCategoryMutationVariables>(UpdateTagCategoryDocument, options);
      }
export type UpdateTagCategoryMutationHookResult = ReturnType<typeof useUpdateTagCategoryMutation>;
export type UpdateTagCategoryMutationResult = Apollo.MutationResult<UpdateTagCategoryMutation>;
export type UpdateTagCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateTagCategoryMutation, UpdateTagCategoryMutationVariables>;
export const DeleteTagCategoryDocument = gql`
    mutation deleteTagCategory($id: Int!) {
  deleteTagCategory(id: $id)
}
    `;
export type DeleteTagCategoryMutationFn = Apollo.MutationFunction<DeleteTagCategoryMutation, DeleteTagCategoryMutationVariables>;

/**
 * __useDeleteTagCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteTagCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagCategoryMutation, { data, loading, error }] = useDeleteTagCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagCategoryMutation, DeleteTagCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagCategoryMutation, DeleteTagCategoryMutationVariables>(DeleteTagCategoryDocument, options);
      }
export type DeleteTagCategoryMutationHookResult = ReturnType<typeof useDeleteTagCategoryMutation>;
export type DeleteTagCategoryMutationResult = Apollo.MutationResult<DeleteTagCategoryMutation>;
export type DeleteTagCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteTagCategoryMutation, DeleteTagCategoryMutationVariables>;
export const GetTagsDocument = gql`
    query getTags($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  tags(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      id
      name
      systemId
      description
      updatedAt
      updatedByUser {
        id
        username
        email
      }
    }
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetTagDocument = gql`
    query getTag($id: Int) {
  tag(id: $id) {
    ...tagForm
  }
}
    ${TagFormFragmentDoc}`;

/**
 * __useGetTagQuery__
 *
 * To run a query within a React component, call `useGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTagQuery(baseOptions?: Apollo.QueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
      }
export function useGetTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
export function useGetTagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
export type GetTagQueryHookResult = ReturnType<typeof useGetTagQuery>;
export type GetTagLazyQueryHookResult = ReturnType<typeof useGetTagLazyQuery>;
export type GetTagSuspenseQueryHookResult = ReturnType<typeof useGetTagSuspenseQuery>;
export type GetTagQueryResult = Apollo.QueryResult<GetTagQuery, GetTagQueryVariables>;
export const CreateTagDocument = gql`
    mutation createTag($values: TagDtoInput!) {
  createTag(input: {data: $values}) {
    success
    data {
      ...tagForm
    }
  }
}
    ${TagFormFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation updateTag($values: TagDtoInput!) {
  updateTag(input: {data: $values}) {
    success
    data {
      ...tagForm
    }
  }
}
    ${TagFormFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation deleteTag($id: Int!) {
  deleteTag(id: $id)
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const GetVerificationTypesDocument = gql`
    query getVerificationTypes($page: Int!, $size: Int!, $orders: [OrderEntryInput], $filter: FilterExpressionChildInput) {
  verificationTypes(
    query: {page: {page: $page, size: $size}, orders: $orders, filter: $filter}
  ) {
    totalPages
    totalElements
    items {
      id
      name
      systemId
      description
      applyTo
      updatedAt
      updatedByUser {
        id
        username
        email
      }
    }
  }
}
    `;

/**
 * __useGetVerificationTypesQuery__
 *
 * To run a query within a React component, call `useGetVerificationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerificationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerificationTypesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      size: // value for 'size'
 *      orders: // value for 'orders'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetVerificationTypesQuery(baseOptions: Apollo.QueryHookOptions<GetVerificationTypesQuery, GetVerificationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerificationTypesQuery, GetVerificationTypesQueryVariables>(GetVerificationTypesDocument, options);
      }
export function useGetVerificationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVerificationTypesQuery, GetVerificationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerificationTypesQuery, GetVerificationTypesQueryVariables>(GetVerificationTypesDocument, options);
        }
export function useGetVerificationTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVerificationTypesQuery, GetVerificationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVerificationTypesQuery, GetVerificationTypesQueryVariables>(GetVerificationTypesDocument, options);
        }
export type GetVerificationTypesQueryHookResult = ReturnType<typeof useGetVerificationTypesQuery>;
export type GetVerificationTypesLazyQueryHookResult = ReturnType<typeof useGetVerificationTypesLazyQuery>;
export type GetVerificationTypesSuspenseQueryHookResult = ReturnType<typeof useGetVerificationTypesSuspenseQuery>;
export type GetVerificationTypesQueryResult = Apollo.QueryResult<GetVerificationTypesQuery, GetVerificationTypesQueryVariables>;
export const GetVerificationTypeDocument = gql`
    query getVerificationType($id: Int) {
  verificationType(id: $id) {
    ...verificationTypeForm
  }
}
    ${VerificationTypeFormFragmentDoc}`;

/**
 * __useGetVerificationTypeQuery__
 *
 * To run a query within a React component, call `useGetVerificationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerificationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerificationTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVerificationTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetVerificationTypeQuery, GetVerificationTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerificationTypeQuery, GetVerificationTypeQueryVariables>(GetVerificationTypeDocument, options);
      }
export function useGetVerificationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVerificationTypeQuery, GetVerificationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerificationTypeQuery, GetVerificationTypeQueryVariables>(GetVerificationTypeDocument, options);
        }
export function useGetVerificationTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVerificationTypeQuery, GetVerificationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVerificationTypeQuery, GetVerificationTypeQueryVariables>(GetVerificationTypeDocument, options);
        }
export type GetVerificationTypeQueryHookResult = ReturnType<typeof useGetVerificationTypeQuery>;
export type GetVerificationTypeLazyQueryHookResult = ReturnType<typeof useGetVerificationTypeLazyQuery>;
export type GetVerificationTypeSuspenseQueryHookResult = ReturnType<typeof useGetVerificationTypeSuspenseQuery>;
export type GetVerificationTypeQueryResult = Apollo.QueryResult<GetVerificationTypeQuery, GetVerificationTypeQueryVariables>;
export const CreateVerificationTypeDocument = gql`
    mutation createVerificationType($values: VerificationTypeDtoInput!) {
  createVerificationType(input: {data: $values}) {
    success
    data {
      ...verificationTypeForm
    }
  }
}
    ${VerificationTypeFormFragmentDoc}`;
export type CreateVerificationTypeMutationFn = Apollo.MutationFunction<CreateVerificationTypeMutation, CreateVerificationTypeMutationVariables>;

/**
 * __useCreateVerificationTypeMutation__
 *
 * To run a mutation, you first call `useCreateVerificationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVerificationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVerificationTypeMutation, { data, loading, error }] = useCreateVerificationTypeMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useCreateVerificationTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateVerificationTypeMutation, CreateVerificationTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVerificationTypeMutation, CreateVerificationTypeMutationVariables>(CreateVerificationTypeDocument, options);
      }
export type CreateVerificationTypeMutationHookResult = ReturnType<typeof useCreateVerificationTypeMutation>;
export type CreateVerificationTypeMutationResult = Apollo.MutationResult<CreateVerificationTypeMutation>;
export type CreateVerificationTypeMutationOptions = Apollo.BaseMutationOptions<CreateVerificationTypeMutation, CreateVerificationTypeMutationVariables>;
export const UpdateVerificationTypeDocument = gql`
    mutation updateVerificationType($values: VerificationTypeDtoInput!) {
  updateVerificationType(input: {data: $values}) {
    success
    data {
      ...verificationTypeForm
    }
  }
}
    ${VerificationTypeFormFragmentDoc}`;
export type UpdateVerificationTypeMutationFn = Apollo.MutationFunction<UpdateVerificationTypeMutation, UpdateVerificationTypeMutationVariables>;

/**
 * __useUpdateVerificationTypeMutation__
 *
 * To run a mutation, you first call `useUpdateVerificationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVerificationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVerificationTypeMutation, { data, loading, error }] = useUpdateVerificationTypeMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdateVerificationTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVerificationTypeMutation, UpdateVerificationTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVerificationTypeMutation, UpdateVerificationTypeMutationVariables>(UpdateVerificationTypeDocument, options);
      }
export type UpdateVerificationTypeMutationHookResult = ReturnType<typeof useUpdateVerificationTypeMutation>;
export type UpdateVerificationTypeMutationResult = Apollo.MutationResult<UpdateVerificationTypeMutation>;
export type UpdateVerificationTypeMutationOptions = Apollo.BaseMutationOptions<UpdateVerificationTypeMutation, UpdateVerificationTypeMutationVariables>;
export const DeleteVerificationTypeDocument = gql`
    mutation deleteVerificationType($id: Int!) {
  deleteVerificationType(id: $id)
}
    `;
export type DeleteVerificationTypeMutationFn = Apollo.MutationFunction<DeleteVerificationTypeMutation, DeleteVerificationTypeMutationVariables>;

/**
 * __useDeleteVerificationTypeMutation__
 *
 * To run a mutation, you first call `useDeleteVerificationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVerificationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVerificationTypeMutation, { data, loading, error }] = useDeleteVerificationTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVerificationTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVerificationTypeMutation, DeleteVerificationTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVerificationTypeMutation, DeleteVerificationTypeMutationVariables>(DeleteVerificationTypeDocument, options);
      }
export type DeleteVerificationTypeMutationHookResult = ReturnType<typeof useDeleteVerificationTypeMutation>;
export type DeleteVerificationTypeMutationResult = Apollo.MutationResult<DeleteVerificationTypeMutation>;
export type DeleteVerificationTypeMutationOptions = Apollo.BaseMutationOptions<DeleteVerificationTypeMutation, DeleteVerificationTypeMutationVariables>;